<template>
  <!--新建数据校验规则-->
  <div id="myValidationDetail" style="position:relative">
    <div class="head-btn t_r">
      <button @click="goUrl()" class="cancelButton cancelButton2 m_r_10">
        <span>取消</span>
      </button>
       <button @click="allSave()" class="suerButton suerButton2 m_r_10">
        <span>保存</span>
      </button>
       <span @click="$commonJs.backURL" class="btn-back">
          <span>返回</span>
        </span>
    </div>
    <div class="m_t_20 tableHeight" style="overflow: auto">
      <div class="m_b_20">
        <nav class="uhTabDiv">
          <div>
            <span class="onUhTabSpan" style="color:#333 !important">基本信息</span>
          </div>
        </nav>
        <div class="back_colorWidth">
          <dl class="uhTabBodyDiv_dl">
            <dd>
              <span>文件名称:</span>
              <section class="uhNSec">
                <div>
                  <input
                    v-model="detailData.fileName"
                    type="text"
                    class="allInput"
                    style="width: calc(100% - 12px)"
                  />
                </div>
                <div style="width: 45px">
                  <allSelect
                    v-on:on-change="seltSuffix()"
                    v-model="detailData.separator"
                    :chooseData="separatorList"
                    :needReturn="'type'"
                    :matchValue="'name'"
                    :showValue="'{{name}}'"
                    :width="'100%'"
                    :placeholder="'无'"
                    :borderLine="'#E5E5E5'"
                  ></allSelect>
                </div>
                <div v-if="detailData.separator">
                  <allSelect
                    v-model="detailData.suffix"
                    :chooseData="SuffixList"
                    :needReturn="'id'"
                    :matchValue="'name'"
                    :showValue="'{{name}}'"
                    :width="'100%'"
                    :placeholder="'无'"
                    :borderLine="'#E5E5E5'"
                  ></allSelect>
                </div>
              </section>
            </dd>
            <dd>
              <span>文件类型:</span>
              <div>
                <div>
                  <input v-model="detailData.fileType" type="text" class="allInput" />
                  <!--<allSelect v-model="detailData.fileType" :chooseData="fileTypeList" :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" :width="'100%'" :placeholder="'全部'" :borderLine="'#E5E5E5'">-->
                  <!--</allSelect>-->
                </div>
              </div>
            </dd>
            <dd>
              <span>文件格式:</span>
              <div>
                <div>
                  <allSelect
                    v-on:on-change="seltFileType()"
                    v-model="detailData.fileFormat"
                    :chooseData="fileFormatList"
                    :needReturn="'id'"
                    :matchValue="'name'"
                    :showValue="'{{name}}'"
                    :width="'100%'"
                    :placeholder="'全部'"
                    :borderLine="'#E5E5E5'"
                  ></allSelect>
                </div>
              </div>
            </dd>
            <dd>
              <span>上传方式:</span>
              <div>
                <div>
                  <allSelect
                    v-model="detailData.uploadMethod"
                    :chooseData="uploadMethodList"
                    :needReturn="'id'"
                    :matchValue="'name'"
                    :showValue="'{{name}}'"
                    :width="'100%'"
                    :placeholder="'全部'"
                    :borderLine="'#E5E5E5'"
                  ></allSelect>
                </div>
              </div>
            </dd>
            <dd>
              <span>部门:</span>
              <div>
                <div>
                  <input v-model="detailData.bu" type="text" class="allInput" />
                </div>
              </div>
            </dd>
            <dd>
              <span>归属项目:</span>
              <div>
                <div>
                  <input v-model="detailData.projectBelong" type="text" class="allInput" />
                </div>
              </div>
            </dd>
          </dl>
          <div class="freDiv">
            <span>上传频率:</span>
            <div>
              <div class="dis_line Newline" style="width: 100%">
                <div class="d_flex" style="display: inline-flex">
                  <div>
                    <input
                      v-model="detailData.uploadFrequency"
                      :value="1"
                      type="radio"
                      class="allRadio"
                      id="sheetRadio3"
                      name="sheetRadio3"
                    />
                    <label for="sheetRadio3"></label>
                    <label for="sheetRadio3">
                      <span class="m_l_10">按月</span>
                    </label>
                  </div>
                  <div class="d_flex m_r_10">
                    <div class="m_r_5">每月第</div>
                    <div>
                      <input
                        @blur="verifyWorkday(1)"
                        v-model="mouthTimeOne"
                        type="number"
                        class="allInput"
                        style="width: 21px"
                        :disabled="parseInt(detailData.uploadFrequency) === 2"
                      />
                    </div>
                    <div class="m_l_5 m_r_5">、</div>
                    <div>
                      <input
                        @blur="verifyWorkday(2)"
                        v-model="mouthTimeTwo"
                        type="number"
                        class="allInput"
                        style="width: 21px"
                        :disabled="parseInt(detailData.uploadFrequency) === 2"
                      />
                    </div>
                    <div class="m_l_5">个工作日</div>
                  </div>
                </div>
                <div class="d_flex" style="display: inline-flex">
                  <div class="m_l_20">
                    <input
                      v-model="detailData.uploadFrequency"
                      :value="2"
                      type="radio"
                      class="allRadio"
                      id="sheetRadio4"
                      name="sheetRadio3"
                    />
                    <label for="sheetRadio4"></label>
                    <label for="sheetRadio4">
                      <span class="m_l_10">按年</span>
                    </label>
                  </div>
                  <div class="d_flex">
                    <div style="width: 60px">
                      <allSelect
                        v-model="yearOne"
                        :chooseData="yearOneList"
                        :needReturn="'id'"
                        :matchValue="'name'"
                        :showValue="'{{name}}'"
                        :width="'100%'"
                        :placeholder="'全部'"
                        :borderLine="'#E5E5E5'"
                        :disabled="parseInt(detailData.uploadFrequency) === 1"
                      ></allSelect>
                    </div>
                    <div class="m_l_5">第</div>
                    <div class="m_l_5">
                      <input
                        @blur="verifyWorkday(3)"
                        v-model="yearOneTime"
                        type="number"
                        class="allInput"
                        style="width: 21px"
                        :disabled="parseInt(detailData.uploadFrequency) === 1"
                      />
                    </div>
                    <div class="m_l_5">个工作日</div>
                    <div class="m_l_5 colorYellowF36A20">&</div>
                    <div style="width: 60px" class="m_l_5">
                      <allSelect
                        v-model="yearTwo"
                        :chooseData="yearTwoList"
                        :needReturn="'id'"
                        :matchValue="'name'"
                        :showValue="'{{name}}'"
                        :width="'100%'"
                        :placeholder="'全部'"
                        :borderLine="'#E5E5E5'"
                        :disabled="parseInt(detailData.uploadFrequency) === 1"
                      ></allSelect>
                    </div>
                    <div class="m_l_5">第</div>
                    <div class="m_l_5">
                      <input
                        @blur="verifyWorkday(4)"
                        v-model="yearTwoTime"
                        type="number"
                        class="allInput"
                        style="width: 21px"
                        :disabled="parseInt(detailData.uploadFrequency) === 1"
                      />
                    </div>
                    <div class="m_l_5">个工作日</div>
                  </div>
                </div>
                <div style="display:inline-block;">
                  <div class="m_l_20">
                    <input
                      v-model="detailData.uploadFrequency"
                      :value="3"
                      type="radio"
                      class="allRadio"
                      id="sheetRadio5"
                      name="sheetRadio3"
                    />
                    <label for="sheetRadio5"></label>
                    <label for="sheetRadio5">
                      <span class="m_l_10">不定时</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <dl class="uhTabBodyDiv_dl">
            <dd>
              <span>邮件提醒人:</span>
              <section class="uhNSec">
                <div>
                  <input
                    @blur="forgetEmail(1)"
                    v-model="detailData.mainEmailReminder"
                    type="text"
                    class="allInput"
                    style="width: calc(100% - 12px)"
                  />
                  <!--<allSelect :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" :width="'100%'" :placeholder="'全部'" :borderLine="'#E5E5E5'">-->
                  <!--</allSelect>-->
                </div>
                <div style="visibility: hidden">-</div>
                <div>
                  <input
                    v-model="detailData.isEnabledMainEmailReminder"
                    type="checkbox"
                    class="allCheckbox"
                    id="emPel"
                  />
                  <label for="emPel"></label>
                  <label for="emPel">
                    <span class="m_l_10">开启邮件提醒</span>
                  </label>
                </div>
              </section>
            </dd>
            <dd>
              <span>邮件Backup:</span>
              <section class="uhNSec">
                <div>
                  <input
                    @blur="forgetEmail(2)"
                    v-model="detailData.backupEmailReminder"
                    type="text"
                    class="allInput"
                    style="width: calc(100% - 12px)"
                  />
                  <!--<allSelect :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" :width="'100%'" :placeholder="'全部'" :borderLine="'#E5E5E5'">-->
                  <!--</allSelect>-->
                </div>
                <div style="visibility: hidden">-</div>
                <div>
                  <input
                    v-model="detailData.isEnabledBackupEmailReminder"
                    type="checkbox"
                    class="allCheckbox"
                    id="emPelBackup"
                  />
                  <label for="emPelBackup"></label>
                  <label for="emPelBackup">
                    <span class="m_l_10">开启邮件提醒</span>
                  </label>
                </div>
              </section>
            </dd>
            <dt
              style="width: 49%"
              class="dis_line v_m"
              v-if="parseInt(detailData.fileFormat) === 1"
            >
              <span class="t_r">Sheet个数是否固定:</span>
              <div>
                <input
                  @change="seltFixedSheet()"
                  v-model="detailData.isFixedSheet"
                  :value="true"
                  type="radio"
                  class="allRadio"
                  id="sheetRadio1"
                  name="sheetRadio1"
                />
                <label for="sheetRadio1" class="m_l_20"></label>
                <label for="sheetRadio1">
                  <span class="m_l_10">是</span>
                </label>
                <input
                  @change="seltFixedSheet()"
                  v-model="detailData.isFixedSheet"
                  :value="false"
                  type="radio"
                  class="allRadio"
                  id="sheetRadio2"
                  name="sheetRadio1"
                />
                <label for="sheetRadio2" class="m_l_20"></label>
                <label for="sheetRadio2">
                  <span class="m_l_10">否</span>
                </label>
              </div>
            </dt>
            <dd>
              <span>文件大小:</span>
              <div>
                <div>
                  <div class="d_flex m_l_5 m_r_10" style="justify-content: flex-start">
                    <div class="m_r_5">不超过</div>
                    <div>
                      <input
                        @blur="verifyNumM()"
                        v-model="detailData.fileSizeLimit"
                        type="number"
                        class="allInput"
                        style="width: 30px"
                      />
                    </div>
                    <div class="m_l_5">M（最大支持200M）</div>
                  </div>
                </div>
              </div>
            </dd>
            <dd>
              <span>blob账号:</span>
              <section class="uhNSec">
                <div style="width: 45%">
                  <allSelect
                    v-on:on-change="seltBlobAccount()"
                    v-model="detailData.account"
                    :chooseData="accountList"
                    :needReturn="'name'"
                    :matchValue="'name'"
                    :showValue="'{{name}}'"
                    :width="'100%'"
                    :placeholder="'请选择'"
                    :borderLine="'#E5E5E5'"
                  ></allSelect>
                </div>
                <div style="width: 45%">
                  <allSelect
                    v-on:on-change="seltBlobContainer()"
                    v-model="detailData.container"
                    :chooseData="containerList"
                    :needReturn="'name'"
                    :matchValue="'name'"
                    :showValue="'{{name}}'"
                    :width="'100%'"
                    :placeholder="'请选择'"
                    :borderLine="'#E5E5E5'"
                  ></allSelect>
                </div>
              </section>
            </dd>
            <!--<dd style="width: 100%;margin: 0 0 20px 0">-->
            <dd>
              <span>上传路径:</span>
              <div>
                <section class="uhNSec">
                  <div style="width: 30%">
                    <input
                      v-model="detailData.startPath"
                      type="text"
                      class="allInput"
                      style="width: calc(100% - 12px)"
                    />
                  </div>
                  <div style="width: 8px">-</div>
                  <div style="width: 20%">
                    <allSelect
                      v-model="detailData.midPath"
                      :chooseData="pathTime"
                      :needReturn="'id'"
                      :matchValue="'name'"
                      :showValue="'{{name}}'"
                      :width="'100%'"
                      :placeholder="'无'"
                      :borderLine="'#E5E5E5'"
                    ></allSelect>
                  </div>
                  <div v-if="detailData.midPath" style="width: 8px">-</div>
                  <div v-if="detailData.midPath" style="width: 30%">
                    <input
                      v-model="detailData.endPath"
                      type="text"
                      class="allInput"
                      style="width: calc(100% - 12px)"
                    />
                  </div>
                </section>
              </div>
            </dd>
            <dd>
              <span>归档方式:</span>
              <div>
                <div>
                  <allSelect
                    v-model="detailData.archiveType"
                    :chooseData="placeMethodList"
                    :needReturn="'id'"
                    :matchValue="'name'"
                    :showValue="'{{name}}'"
                    :width="'100%'"
                    :placeholder="'全部'"
                    :borderLine="'#E5E5E5'"
                  ></allSelect>
                </div>
              </div>
            </dd>
          </dl>
        </div>
      </div>
      <div>
        <div v-show="detailData.isFixedSheet">
          <nav class="uhTabDiv" v-if="parseInt(detailData.fileFormat) === 1">
            <div>
              <ul>
                <li
                  @click="seltSheetTab(indexTop)"
                  :class="seltSheet === indexTop ? 'onUhTabLi' : ''"
                  :key="indexTop"
                  v-for="(itemTop, indexTop) in fixedSheetTrueData"
                >
                  <div>
                    <!--<span v-if="!itemTop.isEdit">{{ itemTop.sheetName }}</span>-->
                    <input
                      v-model="itemTop.sheetName"
                      type="text"
                      class="allInput"
                      style="width: 88px;background-color: transparent;border: none"
                      placeholder="请输入sheet名"
                    />
                    <!-- <i v-if="fixedSheetTrueData.length > 1" @click.stop="deltSheetTop(indexTop)" class="icon iconfont iconguanbi colorYellowF36A20"></i> -->
                    <i
                      @click.stop="deltSheetTop(indexTop)"
                      class="icon iconfont iconguanbi colorYellowF36A20"
                    ></i>
                  </div>
                </li>
              </ul>
            </div>
            <div @click="addSheet()">
              <i class="icon iconfont iconicon02 colorYellowF36A20 f_w" style="font-size: 20px"></i>
            </div>
          </nav>
          <div
            v-show="seltSheet === indexBody"
            class="back_colorWidth"
            :key="indexBody"
            v-for="(itemBody, indexBody) in fixedSheetTrueData"
          >
            <div class="sytmgSpan pd_20">
              <span
                @click="seltSenior(itemBody, 1, indexBody)"
                :class="itemBody.isSenior === 1 ? 'onValSpan':''"
              >基本规则</span>
              <span
                @click="seltSenior(itemBody, 2, indexBody)"
                :class="itemBody.isSenior === 2 ? 'onValSpan':''"
              >高级规则</span>
            </div>
            <!--基本规则-->
            <div v-if="itemBody.isSenior === 1">
              <div>
                <div class="d_flex p_L_20 p_r_20">
                  <div>
                    <div class="d_flex">
                      <div class="m_l_5">从第</div>
                      <div class="m_l_5">
                        <input
                          @blur="startPositLin(itemBody)"
                          v-model="itemBody.startPosition"
                          type="number"
                          class="allInput"
                          style="width: 21px"
                        />
                      </div>
                      <div class="m_l_5">行开始校验</div>
                    </div>
                  </div>
                  <div>
                    <button
                      @click="deltAllSheet(indexBody)"
                      class="suerButtonSolid btn-dele1 m_r_5"
                      :disabled="pickSheetJointOne"
                    >
                      <span>删除</span>
                    </button>
                    <button
                      @click="addJoint(1, itemBody,indexBody)"
                      class="btn-white m_r_5"
                      :disabled="pickSheetJointBut"
                    >
                      <img src="@/assets/icons/icon-bellSimple.png" width="16px" />
                      <span class="m_l_5">联合查重</span>
                    </button>
                    <button @click="addNewRule(indexBody)" class="btn-white">
                      <i class="el-icon-plus"></i>
                      <span class="m_l_5">新建规则</span>
                    </button>
                  </div>
                </div>
                <div class="pd_20">
                  <table
                    class="allTable"
                    cellspacing="0"
                    v-if="itemBody.uploadRuleItems && itemBody.uploadRuleItems.length"
                  >
                    <thead>
                      <tr>
                        <th>
                          <input
                            @change="titleCheckOne(indexBody)"
                            v-model="itemBody.isCheckFather"
                            type="checkbox"
                            class="allCheckbox"
                            :id="'farCheckTrue' + seltSheet + indexBody"
                          />
                          <label :for="'farCheckTrue' + seltSheet + indexBody"></label>
                        </th>
                        <th width="50">序号</th>
                        <th>列名</th>
                        <th>是否允许为空</th>
                        <th>格式类型</th>
                        <th>是否查重</th>
                        <th>限制内容</th>
                        <th>操作</th>
                      </tr>
                    </thead>
                    <!--<tbody>-->
                    <draggable
                      tag="tbody"
                      :list="itemBody.uploadRuleItems"
                      :move="checkMove"
                      v-bind="{animation: 300,handle:'.moveIcon'}"
                    >
                      <tr
                        :key="indexBody_child"
                        v-for="(itemBody_child, indexBody_child) in itemBody.uploadRuleItems"
                      >
                        <td>
                          <input
                            @change="listCheckedOne(indexBody)"
                            v-model="itemBody_child.isCheckChild"
                            type="checkbox"
                            class="allCheckbox"
                            :id="'cilCheckTrue' + seltSheet + indexBody + indexBody_child"
                          />
                          <label :for="'cilCheckTrue' + seltSheet + indexBody + indexBody_child"></label>
                        </td>
                        <td>{{ indexBody_child + 1 }}</td>
                        <td>
                          <i
                            v-if="itemBody_child.isUnionCheckRepeat"
                            class="icon iconfont iconguanlian colorYellowF36A20"
                          ></i>
                          <input
                            @blur="redoColumnName(indexBody, indexBody_child, itemBody_child)"
                            v-model="itemBody_child.columnName"
                            type="text"
                            class="allInput"
                            style="width: 80px"
                          />
                        </td>
                        <td>
                          <div style="width: 100px;margin: auto">
                            <allSelect
                              v-model="itemBody_child.isAllowNull"
                              :chooseData="itemBody_child.allowNullList"
                              :needReturn="'id'"
                              :matchValue="'name'"
                              :showValue="'{{name}}'"
                              :width="'100%'"
                              :placeholder="'全部'"
                              :borderLine="'#E5E5E5'"
                            ></allSelect>
                          </div>
                        </td>
                        <td>
                          <div style="margin: auto;width: 100px;">
                            <allSelect
                              v-model="itemBody_child.fieldType"
                              :chooseData="itemBody_child.sheetfieldTypeList"
                              :needReturn="'id'"
                              :matchValue="'name'"
                              :showValue="'{{name}}'"
                              :width="'100%'"
                              :placeholder="'全部'"
                              :borderLine="'#E5E5E5'"
                            ></allSelect>
                          </div>
                          <div
                            v-if="parseInt(itemBody_child.fieldType) === 1 || parseInt(itemBody_child.fieldType) === 4"
                            class="d_flex m_t_10"
                            style="justify-content: flex-start;width: 100px;margin: 10px auto 0 auto"
                          >
                            <span>数字</span>
                            <div style="width: 80px;margin: 0 auto 0 5px">
                              <allSelect
                                v-model="itemBody_child.numberFilter"
                                :chooseData="itemBody_child.numType"
                                :needReturn="'id'"
                                :matchValue="'name'"
                                :showValue="'{{name}}'"
                                :width="'100%'"
                                :placeholder="'全部'"
                                :borderLine="'#E5E5E5'"
                              ></allSelect>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div style="margin: auto;width: 100px;">
                            <allSelect
                              v-model="itemBody_child.isCheckRepeat"
                              :chooseData="itemBody_child.checkRepeatList"
                              :needReturn="'id'"
                              :matchValue="'name'"
                              :showValue="'{{name}}'"
                              :width="'100%'"
                              :placeholder="'全部'"
                              :borderLine="'#E5E5E5'"
                            ></allSelect>
                          </div>
                        </td>
                        <td
                          style="max-width: 250px"
                          class="NoWrap"
                          :title="returnTitle(itemBody_child.contentScopeTwo)"
                        >
                          <span
                            @click="addShowRules(itemBody_child, indexBody, indexBody_child)"
                            v-if="itemBody_child.contentScopeTwo.length === 0 && parseInt(itemBody_child.fieldType) === 3"
                            class="colorYellowF36A20 c_p"
                          >添加</span>
                          <span
                            @click="addShowRules(itemBody_child, indexBody, indexBody_child)"
                            :key="conScIndex"
                            v-for="(conScItem, conScIndex) in itemBody_child.contentScopeTwo"
                            v-if="itemBody_child.contentScopeTwo.length > 0 && parseInt(itemBody_child.fieldType) === 3"
                            style="text-decoration-line: underline;color: #505050;max-width: 200px;"
                            class="dis_line Newline c_p"
                          >
                            <abbr v-if="parseInt(conScIndex) !== 0">,</abbr>
                            <abbr>{{ conScItem.name }}</abbr>
                          </span>
                        </td>
                        <td class="colorYellowF36A20" width="120">
                          <span @click="toJoin(indexBody, indexBody_child)" class="m_r_10 c_p">高级规则</span>
                          <!-- <i v-if="itemBody.uploadRuleItems.length > 1" @click="deltfiledList(indexBody,indexBody_child)" class="icon iconfont icondetail m_r_10" title="删除"></i> -->
                          <i
                            @click="deltfiledList(indexBody,indexBody_child)"
                            class="colorDele m_r_10"
                            title="删除"
                          >删除</i>
                          <i
                            class="icon iconfont iconcaidan moveIcon"
                            style="cursor: grabbing"
                            title="上下拖动"
                          ></i>
                        </td>
                      </tr>
                    </draggable>
                    <!--</tbody>-->
                  </table>
                </div>
                <div class="bottom_btn" style="padding:0px 20px">
                  <button @click="addNewRule(indexBody)" class="btn-dashed">
                    <span class="m_l_5">+ 点击添加新规则</span>
                  </button>
                </div>
              </div>
            </div>
            <!--高级规则-->
            <div v-if="itemBody.isSenior === 2">
              <nav class="seniorNavTop d_flex">
                <ul style="width: 100%">
                  <li
                    @click="itemBody.joinNum = jointItemTop.joinFrontTempId"
                    :key="jointIndexTop"
                    v-for="(jointItemTop, jointIndexTop) in itemBody.allSeniorRuleJsonList"
                  >
                    <abbr v-if="jointIndexTop !== 0">/</abbr>
                    <i
                      class="icon iconfont iconchangjing"
                      :class="itemBody.joinNum === jointItemTop.joinFrontTempId ? 'colorYellowF36A20' : ''"
                    ></i>
                    <span
                      :class="itemBody.joinNum === jointItemTop.joinFrontTempId ? 'colorYellowF36A20' : ''"
                    >{{jointItemTop.columnName}}</span>
                  </li>
                </ul>
              </nav>
              <div
                v-if="itemBody.joinNum === jointItembody.joinFrontTempId"
                :key="jointIndexbody"
                v-for="(jointItembody, jointIndexbody) in itemBody.allSeniorRuleJsonList"
              >
                <div class="t_r p_b_10">
                  <button
                    v-if="jointItembody.conditions && jointItembody.conditions.length > 0"
                    @click="deltSenior(indexBody, jointIndexbody)"
                    class="suerButtonSolid"
                  >
                    <span>删除</span>
                  </button>
                  <button
                    v-if="jointItembody.conditions && jointItembody.conditions.length === 0"
                    @click="addNewSenior(indexBody, jointIndexbody)"
                    class="suerButtonSolid"
                  >
                    <span>添加</span>
                  </button>
                </div>
                <div v-if="jointItembody.conditions && jointItembody.conditions.length > 0">
                  <div
                    class="seniorDiv"
                    :key="conditionsIndex"
                    v-for="(conditionsItem, conditionsIndex) in jointItembody.conditions"
                  >
                    <p>
                      <span class="font14 f_w">条件{{conditionsIndex + 1}}</span>
                      <i
                        v-if="jointItembody.conditions && jointItembody.conditions.length > 1"
                        @click="deltCondit(indexBody, jointIndexbody, conditionsIndex)"
                        class="icon iconfont iconguanbi colorYellowF36A20"
                        style="font-size: 20px"
                      ></i>
                    </p>
                    <div class="seniorTermDiv">
                      <nav class="font14 m_b_10 f_w">条件设置</nav>
                      <div class="allDl">
                        <dl
                          class="allDl_width30 allDl_span60"
                          :key="columnsIndex"
                          v-for="(columnsItem, columnsIndex) in conditionsItem.columns"
                        >
                          <dd>
                            <span>{{ columnsIndex + 1 }} &nbsp;&nbsp;列名:</span>
                            <div>
                              <allSelect
                                v-on:on-change="seltColFileType($event, columnsItem, jointIndexbody)"
                                v-model="columnsItem.joinFrontTempId"
                                :chooseData="columnsItem.JointCriteriaName"
                                :needReturn="'joinFrontTempId'"
                                :matchValue="'columnName'"
                                :showValue="'{{columnName}}'"
                                :width="'100%'"
                                :placeholder="'全部'"
                                :borderLine="'#E5E5E5'"
                              ></allSelect>
                            </div>
                          </dd>
                          <dd>
                            <span>操作符:</span>
                            <div>
                              <allSelect
                                v-on:on-change="seltActiveOperator($event, columnsItem, jointIndexbody)"
                                v-model="columnsItem.activeOperator"
                                :chooseData="parseInt(columnsItem.fieldType) === 3 || parseInt(columnsItem.fieldType) === 5 ? columnsItem.JointCriteriaFieldTypeListOne : columnsItem.JointCriteriaFieldTypeListTwo"
                                :needReturn="'id'"
                                :matchValue="'name'"
                                :showValue="'{{name}}'"
                                :width="'100%'"
                                :placeholder="'全部'"
                                :borderLine="'#E5E5E5'"
                              ></allSelect>
                            </div>
                            <!--<div v-if="parseInt(columnsItem.fieldType) === 1 || parseInt(columnsItem.fieldType) === 2 || parseInt(columnsItem.fieldType) === 4">-->
                            <!--  <allSelect v-model="columnsItem.activeOperator" :chooseData="columnsItem.JointCriteriaFieldTypeListTwo" :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" :width="'100%'" :placeholder="'全部'" :borderLine="'#E5E5E5'">-->
                            <!--  </allSelect>-->
                            <!--</div>-->
                          </dd>
                          <dd>
                            <span>值:</span>
                            <div v-if="parseInt(columnsItem.fieldType) !== 2">
                              <input
                                @blur="jointItembody.isOnChange = true"
                                v-model="columnsItem.data"
                                type="text"
                                class="allInput"
                              />
                            </div>
                            <div v-if="parseInt(columnsItem.fieldType) === 2">
                              <canderSFM
                                v-model="columnsItem.data"
                                :className="'allInput'"
                                placeholderName="请选择日期"
                                :newWidth="'100%'"
                                :showTimePicker="true"
                              ></canderSFM>
                            </div>
                          </dd>
                          <dt style="width: 24px">
                            <i
                              v-if="conditionsItem.columns && conditionsItem.columns.length > 1"
                              @click="delColumns(indexBody, jointIndexbody, conditionsIndex, columnsIndex)"
                              class="icon iconfont iconguanbi colorYellowF36A20"
                              style="font-size: 20px"
                            ></i>
                          </dt>
                        </dl>
                      </div>
                      <hr class="m_b_10" />
                      <div class="t_c m_b_20">
                        <button
                          @click="sweetenColumns(indexBody, jointIndexbody, conditionsIndex)"
                          class="suerButton"
                        >
                          <span>添加条件</span>
                        </button>
                      </div>
                      <div
                        class="m_b_20"
                        v-if="conditionsItem.columns && conditionsItem.columns.length > 1"
                      >
                        <nav class="font14 m_b_10 f_w">联动设置</nav>
                        <ul>
                          <li class="m_b_10">
                            <input
                              @change="jointItembody.isOnChange = true"
                              v-model="conditionsItem.relation"
                              value="and"
                              type="radio"
                              class="allRadio"
                              :id="'seniorRadio' + indexBody + jointIndexbody + conditionsIndex"
                            />
                            <label
                              :for="'seniorRadio' + indexBody + jointIndexbody + conditionsIndex"
                            ></label>
                            <label
                              :for="'seniorRadio' + indexBody + jointIndexbody + conditionsIndex"
                            >
                              <span class="m_l_10">满足所有条件（and）</span>
                            </label>
                          </li>
                          <li>
                            <input
                              @change="jointItembody.isOnChange = true"
                              v-model="conditionsItem.relation"
                              value="or"
                              type="radio"
                              class="allRadio"
                              :id="'seniorRadio1' + indexBody + jointIndexbody + conditionsIndex"
                            />
                            <label
                              :for="'seniorRadio1' + indexBody + jointIndexbody + conditionsIndex"
                            ></label>
                            <label
                              :for="'seniorRadio1' + indexBody + jointIndexbody + conditionsIndex"
                            >
                              <span class="m_l_10">满足部分条件（or）</span>
                            </label>
                          </li>
                        </ul>
                      </div>
                      <div class="p_b_10">
                        <nav class="font14 m_b_10 f_w">结果</nav>
                        <div class="allDl">
                          <dl class="allDl_width30 allDl_span60">
                            <dd>
                              <span>列名:</span>
                              <div>{{conditionsItem.columnName}}</div>
                            </dd>
                            <dd style="width: 20%">
                              <span style="width: 100px" class="t_c">是否允许为空:</span>
                              <div style="width: calc(100% - 106px)">
                                <allSelect
                                  v-on:on-change="jointItembody.isOnChange = true"
                                  v-model="conditionsItem.isAllowNull"
                                  :chooseData="conditionsItem.JointResultAllowNullList"
                                  :needReturn="'id'"
                                  :matchValue="'name'"
                                  :showValue="'{{name}}'"
                                  :width="'100%'"
                                  :placeholder="'全部'"
                                  :borderLine="'#E5E5E5'"
                                ></allSelect>
                              </div>
                            </dd>
                            <dd style="width: 20%">
                              <span style="width: 100px" class="t_c">字符类型:</span>
                              <div style="width: calc(100% - 106px)">
                                <allSelect
                                  v-on:on-change="jointItembody.isOnChange = true"
                                  v-model="conditionsItem.fieldType"
                                  :chooseData="conditionsItem.JointResultFieldTypeList"
                                  :needReturn="'id'"
                                  :matchValue="'name'"
                                  :showValue="'{{name}}'"
                                  :width="'100%'"
                                  :placeholder="'全部'"
                                  :borderLine="'#E5E5E5'"
                                ></allSelect>
                              </div>
                            </dd>
                            <dd
                              style="width: 20%"
                              v-if="parseInt(conditionsItem.fieldType) === 1 || parseInt(conditionsItem.fieldType) === 4"
                            >
                              <span style="width: 100px" class="t_c">数字:</span>
                              <div style="width: calc(100% - 106px)">
                                <allSelect
                                  v-on:on-change="jointItembody.isOnChange = true"
                                  v-model="conditionsItem.numberFilter"
                                  :chooseData="conditionsItem.JointResultNumType"
                                  :needReturn="'id'"
                                  :matchValue="'name'"
                                  :showValue="'{{name}}'"
                                  :width="'100%'"
                                  :placeholder="'全部'"
                                  :borderLine="'#E5E5E5'"
                                ></allSelect>
                              </div>
                            </dd>
                          </dl>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    @click="sweetenCondition(indexBody, jointIndexbody)"
                    class="allTop m_l_20 m_r_20 m_b_20 c_p"
                  >
                    <img src="../../../assets/home01.png" width="100%" style="border-radius: 8px" />
                    <div
                      style="border-radius: 8px;background: linear-gradient(97.71deg, rgba(255, 80, 34, 0.9) 2%, rgba(253, 203, 44, 0.9) 100%)"
                    >添加条件</div>
                  </div>
                  <div class="seniorDiv">
                    <p>
                      <span class="font14 f_w">其他条件</span>
                      <i
                        class="icon iconfont iconguanbi colorYellowF36A20"
                        style="font-size: 20px;visibility: hidden"
                      ></i>
                    </p>
                    <div class="seniorTermDiv">
                      <div class="p_b_10">
                        <nav class="font14 m_b_10 f_w">结果</nav>
                        <div class="allDl">
                          <dl class="allDl_width30 allDl_span60">
                            <dd>
                              <span>列名:</span>
                              <div>{{jointItembody.columnName}}</div>
                            </dd>
                            <dd style="width: 20%">
                              <span style="width: 100px" class="t_c">是否允许为空:</span>
                              <div style="width: calc(100% - 106px)">
                                <allSelect
                                  v-on:on-change="jointItembody.isOnChange = true"
                                  v-model="jointItembody.isAllowNull"
                                  :chooseData="jointItembody.JointResultAllowNullList"
                                  :needReturn="'id'"
                                  :matchValue="'name'"
                                  :showValue="'{{name}}'"
                                  :width="'100%'"
                                  :placeholder="'全部'"
                                  :borderLine="'#E5E5E5'"
                                ></allSelect>
                              </div>
                            </dd>
                            <dd style="width: 20%">
                              <span style="width: 100px" class="t_c">字符类型:</span>
                              <div style="width: calc(100% - 106px)">
                                <allSelect
                                  v-on:on-change="jointItembody.isOnChange = true"
                                  v-model="jointItembody.fieldType"
                                  :chooseData="jointItembody.JointResultFieldTypeList"
                                  :needReturn="'id'"
                                  :matchValue="'name'"
                                  :showValue="'{{name}}'"
                                  :width="'100%'"
                                  :placeholder="'全部'"
                                  :borderLine="'#E5E5E5'"
                                ></allSelect>
                              </div>
                            </dd>
                            <dd
                              style="width: 20%"
                              v-if="parseInt(jointItembody.fieldType) === 1 || parseInt(jointItembody.fieldType) === 4"
                            >
                              <span style="width: 100px" class="t_c">数字:</span>
                              <div style="width: calc(100% - 106px)">
                                <allSelect
                                  v-on:on-change="jointItembody.isOnChange = true"
                                  v-model="jointItembody.numberFilter"
                                  :chooseData="jointItembody.JointResultNumType"
                                  :needReturn="'id'"
                                  :matchValue="'name'"
                                  :showValue="'{{name}}'"
                                  :width="'100%'"
                                  :placeholder="'全部'"
                                  :borderLine="'#E5E5E5'"
                                ></allSelect>
                              </div>
                            </dd>
                          </dl>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="!detailData.isFixedSheet">
          <nav class="uhTabDiv" v-if="parseInt(detailData.fileFormat) === 1">
            <div>
              <section>
                <allSelect
                  v-model="fixedSheetFalse.sheetName"
                  :chooseData="fixedSheetFalseYear"
                  :needReturn="'id'"
                  :matchValue="'name'"
                  :showValue="'{{name}}'"
                  :width="'100%'"
                  :placeholder="'全部'"
                  :borderLine="'#E5E5E5'"
                ></allSelect>
              </section>
            </div>
          </nav>
          <div class="back_colorWidth">
            <div class="sytmgSpan pd_20">
              <span
                @click="seltSenior('', 1)"
                :class="fixedSheetFalse.isSenior === 1 ? 'onValSpan' : ''"
              >基本规则</span>
              <span
                @click="seltSenior('', 2)"
                :class="fixedSheetFalse.isSenior === 2 ? 'onValSpan' : ''"
              >高级规则</span>
            </div>
            <div>
              <div v-if="fixedSheetFalse.isSenior === 1">
                <div class="d_flex p_L_20 p_r_20">
                  <div>
                    <div class="d_flex">
                      <div class="m_l_5">从第</div>
                      <div class="m_l_5">
                        <input
                          @blur="startPositLin()"
                          v-model="fixedSheetFalse.startPosition"
                          type="number"
                          class="allInput"
                          style="width: 21px"
                        />
                      </div>
                      <div class="m_l_5">行开始校验</div>
                    </div>
                  </div>
                  <div>
                    <button
                      @click="deltAllSheet()"
                      class="suerButtonSolid"
                      :disabled="pickSheetJointTwo"
                    >
                      <span>删除</span>
                    </button>
                    <button
                      @click="addJoint(2)"
                      class="suerButton butAfter p_r m_r_10"
                      :disabled="pickSheetJointButTwo"
                    >
                      <i class="icon iconfont iconguanlian"></i>
                      <span class="m_l_5">联合查重</span>
                    </button>
                    <button @click="addNewRule('')" class="suerButton">
                      <span class="m_l_5">新建规则</span>
                    </button>
                  </div>
                </div>
                <div class="pd_20">
                  <table
                    class="allTable"
                    cellspacing="0"
                    v-if="fixedSheetFalse.uploadRuleItems && fixedSheetFalse.uploadRuleItems.length"
                  >
                    <thead>
                      <tr>
                        <th>
                          <input
                            @change="titleCheckTwo()"
                            v-model="fixedSheetFalse.isCheckFather"
                            type="checkbox"
                            class="allCheckbox"
                            id="farCheckFalse"
                          />
                          <label for="farCheckFalse"></label>
                        </th>
                        <th>序号</th>
                        <th>列名</th>
                        <th>是否允许为空</th>
                        <th>格式类型</th>
                        <th>是否查重</th>
                        <th>限制内容</th>
                        <th>操作</th>
                      </tr>
                    </thead>
                    <!--<tbody>-->
                    <draggable
                      tag="tbody"
                      :list="fixedSheetFalse.uploadRuleItems"
                      :move="checkMove"
                      v-bind="{animation: 300,handle:'.moveIcon'}"
                    >
                      <tr
                        :key="sFasIndexBody"
                        v-for="(sFasItemBody, sFasIndexBody) in fixedSheetFalse.uploadRuleItems"
                      >
                        <td>
                          <input
                            @change="listCheckedTwo()"
                            v-model="sFasItemBody.isCheckChild"
                            type="checkbox"
                            class="allCheckbox"
                            :id="'cilCheckFalse' + sFasIndexBody"
                          />
                          <label :for="'cilCheckFalse' + sFasIndexBody"></label>
                        </td>
                        <td>{{ sFasIndexBody + 1 }}</td>
                        <td>
                          <i
                            v-if="sFasItemBody.isUnionCheckRepeat"
                            class="icon iconfont iconguanlian colorYellowF36A20"
                          ></i>
                          <input
                            v-model="sFasItemBody.columnName"
                            type="text"
                            class="allInput"
                            style="width: 80px"
                          />
                        </td>
                        <td>
                          <div style="width: 100px;margin: auto">
                            <allSelect
                              v-model="sFasItemBody.isAllowNull"
                              :chooseData="sFasItemBody.allowNullList"
                              :needReturn="'id'"
                              :matchValue="'name'"
                              :showValue="'{{name}}'"
                              :width="'100%'"
                              :placeholder="'全部'"
                              :borderLine="'#E5E5E5'"
                            ></allSelect>
                          </div>
                        </td>
                        <td>
                          <div style="margin: auto;width: 100px;">
                            <allSelect
                              v-model="sFasItemBody.fieldType"
                              :chooseData="sFasItemBody.sheetfieldTypeList"
                              :needReturn="'id'"
                              :matchValue="'name'"
                              :showValue="'{{name}}'"
                              :width="'100%'"
                              :placeholder="'全部'"
                              :borderLine="'#E5E5E5'"
                            ></allSelect>
                          </div>
                          <div
                            v-if="parseInt(sFasItemBody.fieldType) === 1 || parseInt(sFasItemBody.fieldType) === 4"
                            class="d_flex m_t_10"
                            style="justify-content: flex-start;width: 100px;margin: 10px auto 0 auto"
                          >
                            <span>数字</span>
                            <div style="width: 80px;margin: 0 auto 0 5px">
                              <allSelect
                                v-model="sFasItemBody.numberFilter"
                                :chooseData="sFasItemBody.numType"
                                :needReturn="'id'"
                                :matchValue="'name'"
                                :showValue="'{{name}}'"
                                :width="'100%'"
                                :placeholder="'全部'"
                                :borderLine="'#E5E5E5'"
                              ></allSelect>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div style="margin: auto;width: 100px;">
                            <allSelect
                              v-model="sFasItemBody.isCheckRepeat"
                              :chooseData="sFasItemBody.checkRepeatList"
                              :needReturn="'id'"
                              :matchValue="'name'"
                              :showValue="'{{name}}'"
                              :width="'100%'"
                              :placeholder="'全部'"
                              :borderLine="'#E5E5E5'"
                            ></allSelect>
                          </div>
                        </td>
                        <td
                          style="max-width: 250px"
                          class="NoWrap"
                          :title="returnTitle(sFasItemBody.contentScopeTwo)"
                        >
                          <span
                            @click="addShowRules(sFasItemBody, sFasIndexBody)"
                            v-if="sFasItemBody.contentScopeTwo.length === 0 && parseInt(sFasItemBody.fieldType) === 3"
                            class="colorYellowF36A20 c_p"
                          >添加</span>
                          <span
                            @click="addShowRules(sFasItemBody, sFasIndexBody)"
                            :key="conScIndex"
                            v-for="(conScItem, conScIndex) in sFasItemBody.contentScopeTwo"
                            v-if="sFasItemBody.contentScopeTwo.length > 0 && parseInt(sFasItemBody.fieldType) === 3"
                            style="text-decoration-line: underline;color: #505050;max-width: 200px;"
                            class="dis_line Newline c_p"
                          >
                            <abbr v-if="parseInt(conScIndex) !== 0">,</abbr>
                            <abbr>{{ conScItem.name }}</abbr>
                          </span>
                        </td>
                        <td class="colorYellowF36A20" width="50">
                          <span @click="toJoin('', sFasIndexBody)" class="m_r_10 c_p">高级规则</span>
                          <!-- <i v-if="fixedSheetFalse.uploadRuleItems.length > 1" @click="deltfiledList('', sFasIndexBody)" class="icon iconfont icondetail"></i> -->
                          <i
                            @click="deltfiledList('', sFasIndexBody)"
                            class="icon iconfont icondetail"
                          ></i>
                          <i class="icon iconfont iconcaidan moveIcon" style="cursor: grabbing"></i>
                        </td>
                      </tr>
                    </draggable>
                    <!--</tbody>-->
                  </table>
                   <div class="bottom_btn">
                  <button @click="addNewRule('')" class="suerButton">
                    <span class="m_l_5">新建规则</span>
                  </button>
                </div>
                </div>
              </div>
              <div v-if="fixedSheetFalse.isSenior === 2">
                <nav class="seniorNavTop d_flex">
                  <ul style="width: 100%">
                    <li
                      @click="fixedSheetFalse.joinNum = jointItemTop.joinFrontTempId"
                      :key="jointIndexTop"
                      v-for="(jointItemTop, jointIndexTop) in fixedSheetFalse.allSeniorRuleJsonList"
                    >
                      <abbr v-if="jointIndexTop !== 0">/</abbr>
                      <i
                        class="icon iconfont iconchangjing"
                        :class="fixedSheetFalse.joinNum === jointItemTop.joinFrontTempId ? 'colorYellowF36A20' : ''"
                      ></i>
                      <span
                        :class="fixedSheetFalse.joinNum === jointItemTop.joinFrontTempId ? 'colorYellowF36A20' : ''"
                      >{{jointItemTop.columnName}}</span>
                    </li>
                  </ul>
                </nav>
                <div
                  v-if="fixedSheetFalse.joinNum === jointItembody.joinFrontTempId"
                  :key="jointIndexbody"
                  v-for="(jointItembody, jointIndexbody) in fixedSheetFalse.allSeniorRuleJsonList"
                >
                  <div class="t_r p_b_10">
                    <button
                      v-if="jointItembody.conditions && jointItembody.conditions.length > 0"
                      @click="deltSenior('', jointIndexbody)"
                      class="suerButtonSolid"
                    >
                      <span>删除</span>
                    </button>
                    <button
                      v-if="jointItembody.conditions && jointItembody.conditions.length === 0"
                      @click="addNewSenior('', jointIndexbody)"
                      class="suerButtonSolid"
                    >
                      <span>添加</span>
                    </button>
                  </div>
                  <div v-if="jointItembody.conditions && jointItembody.conditions.length > 0">
                    <div
                      class="seniorDiv"
                      :key="conditionsIndex"
                      v-for="(conditionsItem, conditionsIndex) in jointItembody.conditions"
                    >
                      <p>
                        <span class="font14 f_w">条件{{conditionsIndex + 1}}</span>
                        <i
                          v-if="jointItembody.conditions.length > 1"
                          @click="deltCondit('', jointIndexbody, conditionsIndex)"
                          class="icon iconfont iconguanbi colorYellowF36A20"
                          style="font-size: 20px"
                        ></i>
                      </p>
                      <div class="seniorTermDiv">
                        <nav class="font14 m_b_10 f_w">条件设置</nav>
                        <div class="allDl">
                          <dl
                            class="allDl_width30 allDl_span60"
                            :key="columnsIndex"
                            v-for="(columnsItem, columnsIndex) in conditionsItem.columns"
                          >
                            <dd>
                              <span>{{ columnsIndex + 1 }} &nbsp;&nbsp;列名:</span>
                              <div>
                                <allSelect
                                  v-on:on-change="seltColFileType($event, columnsItem, jointIndexbody)"
                                  v-model="columnsItem.joinFrontTempId"
                                  :chooseData="columnsItem.JointCriteriaName"
                                  :needReturn="'joinFrontTempId'"
                                  :matchValue="'columnName'"
                                  :showValue="'{{columnName}}'"
                                  :width="'100%'"
                                  :placeholder="'全部'"
                                  :borderLine="'#E5E5E5'"
                                ></allSelect>
                              </div>
                            </dd>
                            <dd>
                              <span>操作符:</span>
                              <div>
                                <allSelect
                                  v-on:on-change="seltActiveOperator($event, columnsItem, jointIndexbody)"
                                  v-model="columnsItem.activeOperator"
                                  :chooseData="parseInt(columnsItem.fieldType) === 3 || parseInt(columnsItem.fieldType) === 5 ? columnsItem.JointCriteriaFieldTypeListOne : columnsItem.JointCriteriaFieldTypeListTwo"
                                  :needReturn="'id'"
                                  :matchValue="'name'"
                                  :showValue="'{{name}}'"
                                  :width="'100%'"
                                  :placeholder="'全部'"
                                  :borderLine="'#E5E5E5'"
                                ></allSelect>
                              </div>
                              <!--<div v-if="parseInt(columnsItem.fieldType) === 1 || parseInt(columnsItem.fieldType) === 2 || parseInt(columnsItem.fieldType) === 4">-->
                              <!--  <allSelect v-model="columnsItem.activeOperator" :chooseData="columnsItem.JointCriteriaFieldTypeListTwo" :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" :width="'100%'" :placeholder="'全部'" :borderLine="'#E5E5E5'">-->
                              <!--  </allSelect>-->
                              <!--</div>-->
                            </dd>
                            <dd>
                              <span>值:</span>
                              <div v-if="parseInt(columnsItem.fieldType) !== 2">
                                <input
                                  @blur="jointItembody.isOnChange = true"
                                  v-model="columnsItem.data"
                                  type="text"
                                  class="allInput"
                                />
                              </div>
                              <div v-if="parseInt(columnsItem.fieldType) === 2">
                                <canderSFM
                                  v-model="columnsItem.data"
                                  :className="'allInput'"
                                  placeholderName="请选择日期"
                                  :newWidth="'100%'"
                                  :showTimePicker="true"
                                ></canderSFM>
                              </div>
                            </dd>
                            <dt style="width: 24px">
                              <i
                                v-if="conditionsItem.columns.length > 1"
                                @click="delColumns('', jointIndexbody, conditionsIndex, columnsIndex)"
                                class="icon iconfont iconguanbi colorYellowF36A20"
                                style="font-size: 20px"
                              ></i>
                            </dt>
                          </dl>
                        </div>
                        <hr class="m_b_10" />
                        <div class="t_c m_b_20">
                          <button
                            @click="sweetenColumns('', jointIndexbody, conditionsIndex)"
                            class="suerButton"
                          >
                            <span>添加条件</span>
                          </button>
                        </div>
                        <div class="m_b_20" v-if="conditionsItem.columns.length > 1">
                          <nav class="font14 m_b_10 f_w">联动设置</nav>
                          <ul>
                            <li class="m_b_10">
                              <input
                                @change="jointItembody.isOnChange = true"
                                v-model="conditionsItem.relation"
                                value="and"
                                type="radio"
                                class="allRadio"
                                :id="'seniorRadio' + jointIndexbody + conditionsIndex"
                              />
                              <label :for="'seniorRadio' + jointIndexbody + conditionsIndex"></label>
                              <label :for="'seniorRadio' + jointIndexbody + conditionsIndex">
                                <span class="m_l_10">满足所有条件（and）</span>
                              </label>
                            </li>
                            <li>
                              <input
                                @change="jointItembody.isOnChange = true"
                                v-model="conditionsItem.relation"
                                value="or"
                                type="radio"
                                class="allRadio"
                                :id="'seniorRadio1' + jointIndexbody + conditionsIndex"
                              />
                              <label :for="'seniorRadio1' + jointIndexbody + conditionsIndex"></label>
                              <label :for="'seniorRadio1' + jointIndexbody + conditionsIndex">
                                <span class="m_l_10">满足部分条件（or）</span>
                              </label>
                            </li>
                          </ul>
                        </div>
                        <div class="p_b_10">
                          <nav class="font14 m_b_10 f_w">结果</nav>
                          <div class="allDl">
                            <dl class="allDl_width30 allDl_span60">
                              <dd>
                                <span>列名:</span>
                                <div>{{conditionsItem.columnName}}</div>
                              </dd>
                              <dd style="width: 20%">
                                <span style="width: 100px" class="t_c">是否允许为空:</span>
                                <div style="width: calc(100% - 106px)">
                                  <allSelect
                                    v-on:on-change="jointItembody.isOnChange = true"
                                    v-model="conditionsItem.isAllowNull"
                                    :chooseData="conditionsItem.JointResultAllowNullList"
                                    :needReturn="'id'"
                                    :matchValue="'name'"
                                    :showValue="'{{name}}'"
                                    :width="'100%'"
                                    :placeholder="'全部'"
                                    :borderLine="'#E5E5E5'"
                                  ></allSelect>
                                </div>
                              </dd>
                              <dd style="width: 20%">
                                <span style="width: 100px" class="t_c">字符类型:</span>
                                <div style="width: calc(100% - 106px)">
                                  <allSelect
                                    v-on:on-change="jointItembody.isOnChange = true"
                                    v-model="conditionsItem.fieldType"
                                    :chooseData="conditionsItem.JointResultFieldTypeList"
                                    :needReturn="'id'"
                                    :matchValue="'name'"
                                    :showValue="'{{name}}'"
                                    :width="'100%'"
                                    :placeholder="'全部'"
                                    :borderLine="'#E5E5E5'"
                                  ></allSelect>
                                </div>
                              </dd>
                              <dd
                                style="width: 20%"
                                v-if="parseInt(conditionsItem.fieldType) === 1 || parseInt(conditionsItem.fieldType) === 4"
                              >
                                <span style="width: 100px" class="t_c">数字:</span>
                                <div style="width: calc(100% - 106px)">
                                  <allSelect
                                    v-on:on-change="jointItembody.isOnChange = true"
                                    v-model="conditionsItem.numberFilter"
                                    :chooseData="conditionsItem.JointResultNumType"
                                    :needReturn="'id'"
                                    :matchValue="'name'"
                                    :showValue="'{{name}}'"
                                    :width="'100%'"
                                    :placeholder="'全部'"
                                    :borderLine="'#E5E5E5'"
                                  ></allSelect>
                                </div>
                              </dd>
                            </dl>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      @click="sweetenCondition('', jointIndexbody)"
                      class="allTop m_l_20 m_r_20 m_b_20 c_p"
                    >
                      <img src="../../../assets/home01.png" width="100%" style="border-radius: 8px" />
                      <div
                        style="border-radius: 8px;background: linear-gradient(97.71deg, rgba(255, 80, 34, 0.9) 2%, rgba(253, 203, 44, 0.9) 100%)"
                      >添加条件</div>
                    </div>
                    <div class="seniorDiv">
                      <p>
                        <span class="font14 f_w">其他条件</span>
                        <i
                          class="icon iconfont iconguanbi colorYellowF36A20"
                          style="font-size: 20px;visibility: hidden"
                        ></i>
                      </p>
                      <div class="seniorTermDiv">
                        <div class="p_b_10">
                          <nav class="font14 m_b_10 f_w">结果</nav>
                          <div class="allDl">
                            <dl class="allDl_width30 allDl_span60">
                              <dd>
                                <span>列名:</span>
                                <div>{{jointItembody.columnName}}</div>
                              </dd>
                              <dd style="width: 20%">
                                <span style="width: 100px" class="t_c">是否允许为空:</span>
                                <div style="width: calc(100% - 106px)">
                                  <allSelect
                                    v-on:on-change="jointItembody.isOnChange = true"
                                    v-model="jointItembody.isAllowNull"
                                    :chooseData="jointItembody.JointResultAllowNullList"
                                    :needReturn="'id'"
                                    :matchValue="'name'"
                                    :showValue="'{{name}}'"
                                    :width="'100%'"
                                    :placeholder="'全部'"
                                    :borderLine="'#E5E5E5'"
                                  ></allSelect>
                                </div>
                              </dd>
                              <dd style="width: 20%">
                                <span style="width: 100px" class="t_c">字符类型:</span>
                                <div style="width: calc(100% - 106px)">
                                  <allSelect
                                    v-on:on-change="jointItembody.isOnChange = true"
                                    v-model="jointItembody.fieldType"
                                    :chooseData="jointItembody.JointResultFieldTypeList"
                                    :needReturn="'id'"
                                    :matchValue="'name'"
                                    :showValue="'{{name}}'"
                                    :width="'100%'"
                                    :placeholder="'全部'"
                                    :borderLine="'#E5E5E5'"
                                  ></allSelect>
                                </div>
                              </dd>
                              <dd
                                style="width: 20%"
                                v-if="parseInt(jointItembody.fieldType) === 1 || parseInt(jointItembody.fieldType) === 4"
                              >
                                <span style="width: 100px" class="t_c">数字:</span>
                                <div style="width: calc(100% - 106px)">
                                  <allSelect
                                    v-on:on-change="jointItembody.isOnChange = true"
                                    v-model="jointItembody.numberFilter"
                                    :chooseData="jointItembody.JointResultNumType"
                                    :needReturn="'id'"
                                    :matchValue="'name'"
                                    :showValue="'{{name}}'"
                                    :width="'100%'"
                                    :placeholder="'全部'"
                                    :borderLine="'#E5E5E5'"
                                  ></allSelect>
                                </div>
                              </dd>
                            </dl>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <model
      v-if="showModel"
      :title="'限制内容'"
      :minWidth="'40%'"
      :onButton="1"
      v-on:on-cancel="showModel = false"
      v-on:on-confirm="confixModel()"
    >
      <div class="fixModelDiv">
        <dl>
          <dd :key="index" v-for="(item, index) in fixModelList">
            <input v-model="item.name" type="text" class="allInput" />
            <div @click="deltFixInput(index)">-</div>
          </dd>
          <dt>
            <div @click="addFixdInput()">+</div>
          </dt>
        </dl>
      </div>
    </model>
    <model
      v-if="showModel3"
      :title="'联合查重'"
      :minWidth="'40%'"
      :onButton="1"
      v-on:on-cancel="showModel3 = false"
      v-on:on-confirm="confirmJoint()"
    >
      <div class="pd_20">
        <div class="m_b_10">已选列名</div>
        <ul class="jointUl">
          <li :key="index" v-for="(item, index) in myJointModleList">
            <input
              v-model="item.isUnionCheckRepeat"
              type="checkbox"
              class="allCheckbox"
              :id="'mSheetCheck' + index"
            />
            <label :for="'mSheetCheck' + index"></label>
            <div>
              <span class="dis_line m_r_10">{{ item.columnName }}</span>
              <i @click="rmoveJoint(index)" class="icon iconfont iconguanbi colorYellowF36A20"></i>
            </div>
          </li>
        </ul>
      </div>
    </model>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
export default {
  name: 'myValidationDetail',
  components: {
    draggable
  },
  data () {
    return {
      isRules: false,
      seltSheet: 0,
      formId: parseInt(this.$route.query.formId),
      showModel: false,
      showModel2: false,
      showModel3: false,
      detailData: {
        id: 0,
        fileName: '',
        separator: '',
        suffix: '',
        fileType: '',
        fileFormat: 1,
        uploadMethod: 1,
        bu: '',
        projectBelong: '',
        fileSizeLimit: 0,
        uploadFrequency: 1,
        mainEmailReminder: '',
        backupEmailReminder: '',
        remindTime: '', // 上传频率时间字段
        isEnabledMainEmailReminder: true,
        isEnabledBackupEmailReminder: true,
        isFixedSheet: true,
        sheetId: 0,
        startPath: '',
        midPath: '',
        endPath: '',
        sheets: [],
        account: '',
        container: '',
        archiveType: 1
      },
      separatorList: [
        {
          id: '',
          name: '无',
          type: ''
        },
        {
          id: '',
          name: '-',
          type: '-'
        },
        {
          id: '',
          name: '_',
          type: '_'
        }
      ],
      pathTime: [
        {
          id: '',
          name: '无'
        },
        {
          id: 'yyyy',
          name: 'yyyy'
        },
        {
          id: 'yyyymm',
          name: 'yyyymm'
        }
      ],
      SuffixList: [
        {
          id: 'yyyy',
          name: 'yyyy'
        },
        {
          id: 'yyyymm',
          name: 'yyyymm'
        },
        {
          id: 'yyyymmdd',
          name: 'yyyymmdd'
        }
      ],
      fileTypeList: [
        {
          id: 1,
          name: 'Target'
        },
        {
          id: 2,
          name: '商品码表'
        },
        {
          id: 3,
          name: '出厂价'
        },
        {
          id: 4,
          name: 'spend'
        },
        {
          id: 5,
          name: '权限'
        },
        {
          id: 6,
          name: 'wellness指标对应渠道'
        }
      ],
      fileFormatList: [
        {
          id: 1,
          name: 'Excel'
        },
        {
          id: 2,
          name: 'CSV'
        }
      ],
      uploadMethodList: [
        {
          id: 1,
          name: 'portal'
        },
        {
          id: 2,
          name: 'email'
        }
      ],
      placeMethodList: [
        {
          id: 1,
          name: '定时归档'
        },
        {
          id: 2,
          name: '立即归档'
        }
      ],
      mouthTimeOne: '',
      mouthTimeTwo: '',
      yearOne: '1',
      yearOneTime: '',
      yearOneList: [
        {
          id: 1,
          name: '1月'
        },
        {
          id: 2,
          name: '2月'
        },
        {
          id: 3,
          name: '3月'
        },
        {
          id: 4,
          name: '4月'
        },
        {
          id: 5,
          name: '5月'
        },
        {
          id: 6,
          name: '6月'
        },
        {
          id: 7,
          name: '7月'
        },
        {
          id: 8,
          name: '8月'
        },
        {
          id: 9,
          name: '9月'
        },
        {
          id: 10,
          name: '10月'
        },
        {
          id: 11,
          name: '11月'
        },
        {
          id: 12,
          name: '12月'
        }
      ],
      yearTwo: '1',
      yearTwoTime: '',
      yearTwoList: [
        {
          id: 1,
          name: '1月'
        },
        {
          id: 2,
          name: '2月'
        },
        {
          id: 3,
          name: '3月'
        },
        {
          id: 4,
          name: '4月'
        },
        {
          id: 5,
          name: '5月'
        },
        {
          id: 6,
          name: '6月'
        },
        {
          id: 7,
          name: '7月'
        },
        {
          id: 8,
          name: '8月'
        },
        {
          id: 9,
          name: '9月'
        },
        {
          id: 10,
          name: '10月'
        },
        {
          id: 11,
          name: '11月'
        },
        {
          id: 12,
          name: '12月'
        }
      ],
      joinNum: 0,
      fixedSheetTrueData: [
        {
          id: 0,
          sheetName: '',
          startPosition: 1,
          uploadRuleItems: [
            {
              id: 0,
              joinFrontTempId: '',
              frontTempId: new Date().getTime() + Math.random() * 9999,
              orderId: 0,
              columnName: '',
              isAllowNull: true,
              fieldType: 3,
              numberFilter: 1,
              contentScope: [],
              contentScopeTwo: [],
              isCheckRepeat: false,
              isUnionCheckRepeat: false, // 是否联合查重
              isCheckChild: false,
              // contentScopeString: '',
              allowNullList: [
                {
                  id: true,
                  name: '是'
                },
                {
                  id: false,
                  name: '否'
                }
              ],
              checkRepeatList: [
                {
                  id: true,
                  name: '是'
                },
                {
                  id: false,
                  name: '否'
                }
              ],
              sheetfieldTypeList: [
                {
                  id: 1,
                  name: '浮点型'
                },
                {
                  id: 2,
                  name: '日期型'
                },
                {
                  id: 3,
                  name: '字符串型'
                },
                {
                  id: 4,
                  name: '整型'
                },
                {
                  id: 5,
                  name: '不验证'
                }
              ],
              numType: [
                {
                  id: 1,
                  name: '>0'
                },
                {
                  id: 2,
                  name: '>=0'
                },
                {
                  id: 3,
                  name: '不验证'
                }
              ],
              seniorRuleJson: null
            }
          ],
          allSeniorRuleJsonList: [],
          isSenior: 1, // 基本 高级规则切换
          joinNum: 0,
          isEdit: true, // sheet名字编辑
          isCheckFather: false
        }
      ],
      addJointConditions: {
        columns: [
          {
            id: 0,
            joinFrontTempId: '',
            frontTempId: '',
            columnName: '',
            isAllowNull: true,
            fieldType: 3,
            activeOperator: 0,
            data: '',
            // frontTempId: new Date().getTime() + Math.random() * 9999,
            JointCriteriaName: [], // 条件列名
            JointCriteriaFieldTypeListOne: [
              {
                id: 3,
                name: '='
              },
              {
                id: 6,
                name: '≠'
              }
            ], // 字符串操作符
            JointCriteriaFieldTypeListTwo: [
              {
                id: 1,
                name: '>'
              },
              {
                id: 2,
                name: '>='
              },
              {
                id: 3,
                name: '='
              },
              {
                id: 4,
                name: '<='
              },
              {
                id: 5,
                name: '<'
              },
              {
                id: 6,
                name: '≠'
              }
            ] // 非字符串操作符
          }
        ],
        relation: 'and',
        columnName: '',
        isAllowNull: true,
        fieldType: 3,
        numberFilter: 1,
        orderId: 0,
        JointResultAllowNullList: [
          {
            id: true,
            name: '是'
          },
          {
            id: false,
            name: '否'
          }
        ],
        JointResultFieldTypeList: [
          {
            id: 1,
            name: '浮点型'
          },
          {
            id: 2,
            name: '日期型'
          },
          {
            id: 3,
            name: '字符串型'
          },
          {
            id: 4,
            name: '整型'
          },
          {
            id: 5,
            name: '不验证'
          }
        ],
        JointResultNumType: [
          {
            id: 1,
            name: '>0'
          },
          {
            id: 2,
            name: '>=0'
          },
          {
            id: 3,
            name: '不验证'
          }
        ]
      },
      addColumns: {
        id: 0,
        joinFrontTempId: '',
        frontTempId: '',
        columnName: '',
        isAllowNull: true,
        fieldType: 3,
        activeOperator: 0,
        data: '',
        // frontTempId: new Date().getTime() + Math.random() * 9999,
        JointCriteriaName: [], // 条件列名
        JointCriteriaFieldTypeListOne: [
          {
            id: 3,
            name: '='
          },
          {
            id: 6,
            name: '≠'
          }
        ], // 字符串操作符
        JointCriteriaFieldTypeListTwo: [
          {
            id: 1,
            name: '>'
          },
          {
            id: 2,
            name: '>='
          },
          {
            id: 3,
            name: '='
          },
          {
            id: 4,
            name: '<='
          },
          {
            id: 5,
            name: '<'
          },
          {
            id: 6,
            name: '≠'
          }
        ] // 非字符串操作符
      },
      fixedSheetFalseYear: [
        {
          id: 'yyyy',
          name: 'yyyy'
        },
        {
          id: 'yyyymm',
          name: 'yyyymm'
        }
      ],
      fixedSheetFalse: {
        id: 0,
        sheetName: 'yyyy',
        startPosition: 1,
        uploadRuleItems: [
          {
            id: 0,
            joinFrontTempId: '',
            frontTempId: new Date().getTime() + Math.random() * 9999,
            orderId: 0,
            columnName: '',
            isAllowNull: true,
            fieldType: 3,
            numberFilter: 1,
            contentScope: [],
            contentScopeTwo: [],
            isCheckRepeat: false,
            isUnionCheckRepeat: false, // 是否联合查重
            isCheckChild: false,
            // contentScopeString: '',
            allowNullList: [
              {
                id: true,
                name: '是'
              },
              {
                id: false,
                name: '否'
              }
            ],
            checkRepeatList: [
              {
                id: true,
                name: '是'
              },
              {
                id: false,
                name: '否'
              }
            ],
            sheetfieldTypeList: [
              {
                id: 1,
                name: '浮点型'
              },
              {
                id: 2,
                name: '日期型'
              },
              {
                id: 3,
                name: '字符串型'
              },
              {
                id: 4,
                name: '整型'
              },
              {
                id: 5,
                name: '不验证'
              }
            ],
            numType: [
              {
                id: 1,
                name: '>0'
              },
              {
                id: 2,
                name: '>=0'
              },
              {
                id: 3,
                name: '不验证'
              }
            ],
            seniorRuleJson: null
          }
        ],
        allSeniorRuleJsonList: [],
        isSenior: 1, // 基本 高级规则切换
        joinNum: 0,
        isEdit: true, // sheet名字编辑
        isCheckFather: false
      },
      addSheetData: {
        id: 0,
        sheetName: '',
        startPosition: 1,
        uploadRuleItems: [
          {
            id: 0,
            joinFrontTempId: '',
            frontTempId: new Date().getTime() + Math.random() * 9999,
            orderId: 0,
            columnName: '',
            isAllowNull: true,
            fieldType: 3,
            numberFilter: 1,
            contentScope: [],
            contentScopeTwo: [],
            isCheckRepeat: false,
            isUnionCheckRepeat: false, // 是否联合查重
            isCheckChild: false,
            // contentScopeString: '',
            allowNullList: [
              {
                id: true,
                name: '是'
              },
              {
                id: false,
                name: '否'
              }
            ],
            checkRepeatList: [
              {
                id: true,
                name: '是'
              },
              {
                id: false,
                name: '否'
              }
            ],
            sheetfieldTypeList: [
              {
                id: 1,
                name: '浮点型'
              },
              {
                id: 2,
                name: '日期型'
              },
              {
                id: 3,
                name: '字符串型'
              },
              {
                id: 4,
                name: '整型'
              },
              {
                id: 5,
                name: '不验证'
              }
            ],
            numType: [
              {
                id: 1,
                name: '>0'
              },
              {
                id: 2,
                name: '>=0'
              },
              {
                id: 3,
                name: '不验证'
              }
            ]
          }
        ],
        allSeniorRuleJsonList: [],
        isSenior: 1,
        isEdit: true,
        isCheckFather: false
      },
      addUploadRuleItems: {
        id: 0,
        joinFrontTempId: '',
        frontTempId: new Date().getTime() + Math.random() * 9999,
        orderId: 0,
        columnName: '',
        isAllowNull: true,
        fieldType: 3,
        numberFilter: 1,
        contentScope: [],
        contentScopeTwo: [],
        isCheckRepeat: false,
        isUnionCheckRepeat: false, // 是否联合查重
        isCheckChild: false,
        // contentScopeString: '',
        allowNullList: [
          {
            id: true,
            name: '是'
          },
          {
            id: false,
            name: '否'
          }
        ],
        checkRepeatList: [
          {
            id: true,
            name: '是'
          },
          {
            id: false,
            name: '否'
          }
        ],
        sheetfieldTypeList: [
          {
            id: 1,
            name: '浮点型'
          },
          {
            id: 2,
            name: '日期型'
          },
          {
            id: 3,
            name: '字符串型'
          },
          {
            id: 4,
            name: '整型'
          },
          {
            id: 5,
            name: '不验证'
          }
        ],
        numType: [
          {
            id: 1,
            name: '>0'
          },
          {
            id: 2,
            name: '>=0'
          },
          {
            id: 3,
            name: '不验证'
          }
        ],
        seniorRuleJson: null
      },
      addfixedSheetFalse: {
        id: 0,
        joinFrontTempId: '',
        frontTempId: new Date().getTime() + Math.random() * 9999,
        orderId: 0,
        columnName: '',
        isAllowNull: true,
        fieldType: 3,
        numberFilter: 1,
        contentScope: [],
        contentScopeTwo: [],
        isCheckRepeat: false,
        isUnionCheckRepeat: false, // 是否联合查重
        isCheckChild: false,
        // contentScopeString: '',
        allowNullList: [
          {
            id: true,
            name: '是'
          },
          {
            id: false,
            name: '否'
          }
        ],
        checkRepeatList: [
          {
            id: true,
            name: '是'
          },
          {
            id: false,
            name: '否'
          }
        ],
        sheetfieldTypeList: [
          {
            id: 1,
            name: '浮点型'
          },
          {
            id: 2,
            name: '日期型'
          },
          {
            id: 3,
            name: '字符串型'
          },
          {
            id: 4,
            name: '整型'
          },
          {
            id: 5,
            name: '不验证'
          }
        ],
        numType: [
          {
            id: 1,
            name: '>0'
          },
          {
            id: 2,
            name: '>=0'
          },
          {
            id: 3,
            name: '不验证'
          }
        ],
        seniorRuleJson: null
      },
      fixedOpNum: 1,
      fixedOpList: [],
      fixModelList: [
        {
          name: ''
        }
      ],
      addfixModel: {
        name: ''
      },
      myCtrlFixSheetIndex: 0,
      myCtrlFixSheetIndex_childe: 0,
      fixModelListFasle: [
        {
          name: ''
        }
      ],
      addfixModelFalse: {
        name: ''
      },
      myCtrlFixSheetFalseIndex: 0,
      myJointModleList: [],
      JointResultAllowNullList: [
        {
          id: true,
          name: '是'
        },
        {
          id: false,
          name: '否'
        }
      ],
      JointResultFieldTypeList: [
        {
          id: 1,
          name: '浮点型'
        },
        {
          id: 2,
          name: '日期型'
        },
        {
          id: 3,
          name: '字符串型'
        },
        {
          id: 4,
          name: '整型'
        },
        {
          id: 5,
          name: '不验证'
        }
      ],
      JointResultNumType: [
        {
          id: 1,
          name: '>0'
        },
        {
          id: 2,
          name: '>=0'
        },
        {
          id: 3,
          name: '不验证'
        }
      ],
      JointCriteriaName: [], // 条件列名
      JointCriteriaFieldTypeListOne: [
        {
          id: 3,
          name: '='
        },
        {
          id: 6,
          name: '≠'
        }
      ], // 字符串操作符
      JointCriteriaFieldTypeListTwo: [
        {
          id: 1,
          name: '>'
        },
        {
          id: 2,
          name: '>='
        },
        {
          id: 3,
          name: '='
        },
        {
          id: 4,
          name: '<='
        },
        {
          id: 5,
          name: '<'
        },
        {
          id: 6,
          name: '≠'
        }
      ], // 非字符串操作符
      blobList: [],
      accountList: []
    }
  },
  created () {
    if (this.formId && this.formId !== 0) {
      this.getAllDetail()
    } else {
      this.fixedSheetTrueData[0].uploadRuleItems[0].joinFrontTempId = this.fixedSheetTrueData[0].uploadRuleItems[0].id + '/' + this.fixedSheetTrueData[0].uploadRuleItems[0].frontTempId
      this.fixedSheetFalse.uploadRuleItems[0].joinFrontTempId = this.fixedSheetFalse.uploadRuleItems[0].id + '/' + this.fixedSheetFalse.uploadRuleItems[0].frontTempId
    }
  },
  mounted () {
    this.getBlobData()
  },
  watch: {
  },
  computed: {
    // 固定sheet联合查重和删除
    pickSheetJointOne () {
      let flag = false
      for (let i = 0; i < this.fixedSheetTrueData[this.seltSheet].uploadRuleItems.length; i++) {
        if (this.fixedSheetTrueData[this.seltSheet].uploadRuleItems[i].isCheckChild) {
          flag = true
        }
      }
      return !flag
    },
    pickSheetJointBut () {
      let flag = false
      let isUn = false
      let num = 0
      for (let j = 0; j < this.fixedSheetTrueData[this.seltSheet].uploadRuleItems.length; j++) {
        if (this.fixedSheetTrueData[this.seltSheet].uploadRuleItems[j].isCheckChild) {
          num++
        }
      }
      for (let j = 0; j < this.fixedSheetTrueData[this.seltSheet].uploadRuleItems.length; j++) {
        if (this.fixedSheetTrueData[this.seltSheet].uploadRuleItems[j].isUnionCheckRepeat) {
          isUn = true
        }
      }
      if (num > 1 || isUn) {
        flag = true
      }
      return !flag
    },
    // 非固定sheet联合查重和删除
    pickSheetJointTwo () {
      let flag = false
      for (let i = 0; i < this.fixedSheetFalse.uploadRuleItems.length; i++) {
        if (this.fixedSheetFalse.uploadRuleItems[i].isCheckChild) {
          flag = true
        }
      }
      return !flag
    },
    pickSheetJointButTwo () {
      let flag = false
      let num = 0
      for (let i = 0; i < this.fixedSheetFalse.uploadRuleItems.length; i++) {
        if (this.fixedSheetFalse.uploadRuleItems[i].isCheckChild || this.fixedSheetFalse.uploadRuleItems[i].isUnionCheckRepeat) {
          num++
        }
      }
      if (num > 1) {
        flag = true
      }
      return !flag
    },
    containerList () {
      let data = this.blobList.filter(item => item.account === this.detailData.account)
      let result = []
      if (data && data.length) {
        for (let i = 0; i < data[0].containers.length; i++) {
          let temp = {
            id: i,
            name: data[0].containers[i]
          }
          result.push(temp)
        }
      }
      return result
    }
  },
  methods: {
    getBlobData () {
      this.$axiox.get('/api/Systems/GetAllAccountContainerMaps').then(msg => {
        this.blobList = JSON.parse(JSON.stringify(msg.data))
        for (let i = 0; i < this.blobList.length; i++) {
          let data = {
            id: i,
            name: this.blobList[i].account
          }
          this.accountList.push(data)
        }
      })
    },
    seltBlobAccount () {

    },
    seltBlobContainer () {

    },
    // 校验重复列名
    redoColumnName (index, indexCl, itemCl) {
      for (let i = 0; i < this.fixedSheetTrueData[index].uploadRuleItems.length; i++) {
        if (this.fixedSheetTrueData[index].uploadRuleItems[i].joinFrontTempId !== itemCl.joinFrontTempId) {
          if (this.fixedSheetTrueData[index].uploadRuleItems[i].columnName !== '' && itemCl.columnName !== '' && this.fixedSheetTrueData[index].uploadRuleItems[i].columnName === itemCl.columnName) {
            this.$commonJs.alertTips({
              type: 'error',
              title: '错误',
              content: '列名不能重复',
              stayTime: 5
            })
            itemCl.columnName = ''
          }
        }
      }
    },
    checkMove (e) {
      // let data = JSON.parse(JSON.stringify(e.relatedContext.list))
      // for (let i = 0; i < e.relatedContext.list.length; i++) {
      //   e.relatedContext.list[i].orderId = parseInt(i++)
      // }
      console.log(e.relatedContext.list)
    },
    getAllDetail () {
      this.$axiox.get('/api/FileSet/UploadItemDetail?id=' + this.formId).then(msg => {
        console.log(msg)
        this.detailData = JSON.parse(JSON.stringify(msg.data))
        // this.detailData.midPath = this.detailData.midPath ? this.detailData.midPath : 0
        for (let i = 0; i < this.detailData.sheets.length; i++) {
          this.detailData.sheets[i].isSenior = 1
          for (let j = 0; j < this.detailData.sheets[i].uploadRuleItems.length; j++) {
            let contSclistFist = []
            if (this.detailData.sheets[i].uploadRuleItems[j].contentScope.length > 0) {
              for (let e = 0; e < this.detailData.sheets[i].uploadRuleItems[j].contentScope.length; e++) {
                let data = {
                  name: this.detailData.sheets[i].uploadRuleItems[j].contentScope[e]
                }
                contSclistFist.push(data)
              }
            }
            if (!this.detailData.sheets[i].uploadRuleItems[j].joinFrontTempId) {
              this.detailData.sheets[i].uploadRuleItems[j].joinFrontTempId = this.detailData.sheets[i].uploadRuleItems[j].id + '/' + this.detailData.sheets[i].uploadRuleItems[j].frontTempId
            }
            // this.detailData.sheets[i].isSenior = 1
            console.log('this.detailData.sheets[i]: ' + this.detailData.sheets[i])
            this.detailData.sheets[i].joinNum = this.detailData.sheets[i].uploadRuleItems[j].joinFrontTempId ? this.detailData.sheets[i].uploadRuleItems[j].joinFrontTempId : ''
            this.detailData.sheets[i].allSeniorRuleJsonList = []
            if (this.detailData.sheets[i].uploadRuleItems[j].seniorRuleJson) {
              this.detailData.sheets[i].uploadRuleItems[j].seniorRuleJson.JointResultAllowNullList = JSON.parse(JSON.stringify(this.JointResultAllowNullList))
              this.detailData.sheets[i].uploadRuleItems[j].seniorRuleJson.JointResultFieldTypeList = JSON.parse(JSON.stringify(this.JointResultFieldTypeList))
              this.detailData.sheets[i].uploadRuleItems[j].seniorRuleJson.JointResultNumType = JSON.parse(JSON.stringify(this.JointResultNumType))
              for (let e = 0; e < this.detailData.sheets[i].uploadRuleItems[j].seniorRuleJson.conditions.length; e++) {
                this.detailData.sheets[i].uploadRuleItems[j].seniorRuleJson.conditions[e].JointResultAllowNullList = JSON.parse(JSON.stringify(this.JointResultAllowNullList))
                this.detailData.sheets[i].uploadRuleItems[j].seniorRuleJson.conditions[e].JointResultFieldTypeList = JSON.parse(JSON.stringify(this.JointResultFieldTypeList))
                this.detailData.sheets[i].uploadRuleItems[j].seniorRuleJson.conditions[e].JointResultNumType = JSON.parse(JSON.stringify(this.JointResultNumType))
                for (let h = 0; h < this.detailData.sheets[i].uploadRuleItems[j].seniorRuleJson.conditions[e].columns.length; h++) {
                  this.detailData.sheets[i].uploadRuleItems[j].seniorRuleJson.conditions[e].columns[h].JointCriteriaName = JSON.parse(JSON.stringify(this.detailData.sheets[i].uploadRuleItems))
                  this.detailData.sheets[i].uploadRuleItems[j].seniorRuleJson.conditions[e].columns[h].JointCriteriaFieldTypeListOne = JSON.parse(JSON.stringify(this.JointCriteriaFieldTypeListOne))
                  this.detailData.sheets[i].uploadRuleItems[j].seniorRuleJson.conditions[e].columns[h].JointCriteriaFieldTypeListTwo = JSON.parse(JSON.stringify(this.JointCriteriaFieldTypeListTwo))
                }
              }
              this.detailData.sheets[i].allSeniorRuleJsonList.push(this.detailData.sheets[i].uploadRuleItems[j].seniorRuleJson)
            }
            this.detailData.sheets[i].uploadRuleItems[j].contentScopeTwo = contSclistFist
            this.detailData.sheets[i].uploadRuleItems[j].allowNullList = JSON.parse(JSON.stringify(this.addUploadRuleItems.allowNullList))
            this.detailData.sheets[i].uploadRuleItems[j].checkRepeatList = JSON.parse(JSON.stringify(this.addUploadRuleItems.checkRepeatList))
            this.detailData.sheets[i].uploadRuleItems[j].sheetfieldTypeList = JSON.parse(JSON.stringify(this.addUploadRuleItems.sheetfieldTypeList))
            this.detailData.sheets[i].uploadRuleItems[j].numType = JSON.parse(JSON.stringify(this.addUploadRuleItems.numType))
            this.detailData.sheets[i].isCheckFather = false
            this.detailData.sheets[i].uploadRuleItems[j].isCheckChild = JSON.parse(JSON.stringify(this.addUploadRuleItems.isCheckChild))
          }
        }
        if (this.detailData.isFixedSheet) {
          this.fixedSheetTrueData = JSON.parse(JSON.stringify(this.detailData.sheets))
        } else {
          this.fixedSheetFalse = JSON.parse(JSON.stringify(this.detailData.sheets[0]))
        }
        let data = []
        data = this.detailData.remindTime.split(',')
        if (parseInt(this.detailData.uploadFrequency) === 1) {
          this.mouthTimeOne = data[0]
          this.mouthTimeTwo = data[1]
        } else if (parseInt(this.detailData.uploadFrequency) === 2) {
          let fistTime = data[0]
          let listTime = data[1]
          let fistTimeData = fistTime.split('/')
          let listTimeData = listTime.split('/')
          this.yearOne = fistTimeData[0]
          this.yearOneTime = fistTimeData[1]
          this.yearTwo = listTimeData[0]
          this.yearTwoTime = listTimeData[1]
        }
      })
    },
    forgetEmail (type) {
      if (parseInt(type) === 1 && this.detailData.mainEmailReminder !== '') {
        if (this.$commonJs.returnDigit(this.detailData.mainEmailReminder, 'email', '请输入正确的邮件提醒人邮箱')) {
          this.detailData.mainEmailReminder = ''
        }
      } else if (parseInt(type) === 2 && this.detailData.backupEmailReminder !== '') {
        if (this.$commonJs.returnDigit(this.detailData.backupEmailReminder, 'email', '请输入正确的邮件Backup邮箱')) {
          this.detailData.backupEmailReminder = ''
        }
      }
    },
    // 校验工作日
    verifyWorkday (type, item) {
      if (parseInt(type) === 1) {
        if (this.mouthTimeOne !== '') {
          if (this.mouthTimeOne <= 0) {
            this.$commonJs.alertTips({
              type: 'error',
              title: '错误',
              content: '工作日不能小于等于0',
              stayTime: 5
            })
            this.mouthTimeOne = ''
          }
          if (this.mouthTimeOne > 31) {
            this.$commonJs.alertTips({
              type: 'error',
              title: '错误',
              content: '工作日不能大于31',
              stayTime: 5
            })
            this.mouthTimeOne = ''
          }
        }
      } else if (parseInt(type) === 2) {
        if (this.mouthTimeTwo !== '') {
          if (this.mouthTimeTwo <= 0) {
            this.$commonJs.alertTips({
              type: 'error',
              title: '错误',
              content: '工作日不能小于等于0',
              stayTime: 5
            })
            this.mouthTimeTwo = ''
          }
          if (this.mouthTimeTwo > 31) {
            this.$commonJs.alertTips({
              type: 'error',
              title: '错误',
              content: '工作日不能大于31',
              stayTime: 5
            })
            this.mouthTimeTwo = ''
          }
        }
      } else if (parseInt(type) === 3) {
        if (this.yearOneTime !== '') {
          if (this.yearOneTime <= 0) {
            this.$commonJs.alertTips({
              type: 'error',
              title: '错误',
              content: '工作日不能小于等于0',
              stayTime: 5
            })
            this.yearOneTime = ''
          }
          if (this.yearOneTime > 31) {
            this.$commonJs.alertTips({
              type: 'error',
              title: '错误',
              content: '工作日不能大于31',
              stayTime: 5
            })
            this.yearOneTime = ''
          }
        }
      } else if (parseInt(type) === 4) {
        if (this.yearTwoTime !== '') {
          if (this.yearTwoTime <= 0) {
            this.$commonJs.alertTips({
              type: 'error',
              title: '错误',
              content: '工作日不能小于等于0',
              stayTime: 5
            })
            this.yearTwoTime = ''
          }
          if (this.yearTwoTime > 31) {
            this.$commonJs.alertTips({
              type: 'error',
              title: '错误',
              content: '工作日不能大于31',
              stayTime: 5
            })
            this.yearTwoTime = ''
          }
        }
      }
    },
    verifyNumM () {
      if (this.detailData.fileSizeLimit === '') {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '文件大小不能为空',
          stayTime: 5
        })
        this.detailData.fileSizeLimit = 0
        return
      }
      if (parseInt(this.detailData.fileSizeLimit) > 200) {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '文件大小不能大于200M',
          stayTime: 5
        })
        this.detailData.fileSizeLimit = 0
      } else if (parseInt(this.detailData.fileSizeLimit) <= 0) {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '文件大小不能小于等于0',
          stayTime: 5
        })
        this.detailData.fileSizeLimit = 0
      }
    },
    addSheet () {
      this.fixedSheetTrueData.push(JSON.parse(JSON.stringify(this.addSheetData)))
    },
    seltSheetTab (index) {
      this.seltSheet = index
      for (let i = 0; i < this.fixedSheetTrueData.length; i++) {
        this.$set(this.fixedSheetTrueData[i], 'isCheckFather', false)
        for (let j = 0; j < this.fixedSheetTrueData[i].uploadRuleItems.length; j++) {
          this.$set(this.fixedSheetTrueData[i].uploadRuleItems[j], 'isCheckChild', false)
        }
      }
    },
    seltFixedSheet () {
      if (this.detailData.isFixedSheet) {
        for (let i = 0; i < this.fixedSheetTrueData.length; i++) {
          this.$set(this.fixedSheetTrueData[i], 'isCheckFather', false)
          for (let j = 0; j < this.fixedSheetTrueData[i].uploadRuleItems.length; j++) {
            this.$set(this.fixedSheetTrueData[i].uploadRuleItems[j], 'isCheckChild', false)
          }
        }
      } else {
        this.fixedSheetFalse.isCheckFather = false
        for (let i = 0; i < this.fixedSheetFalse.uploadRuleItems.length; i++) {
          this.$set(this.fixedSheetFalse.uploadRuleItems[i], 'isCheckChild', false)
        }
      }
    },
    deltSheetTop (index) {
      this.fixedSheetTrueData.splice(index, 1)
      this.seltSheet = 0
      this.$forceUpdate()
    },
    seltSenior (item, type, index) {
      if (this.detailData.isFixedSheet) {
        if (type === 2) {
          item.isSenior = 2
          this.fixedSheetTrueData[index].allSeniorRuleJsonList = []
          for (let i = 0; i < this.fixedSheetTrueData[index].uploadRuleItems.length; i++) {
            if (this.fixedSheetTrueData[index].uploadRuleItems[i].seniorRuleJson) {
              let data = {
                id: this.fixedSheetTrueData[index].uploadRuleItems[i].id > 0 ? this.fixedSheetTrueData[index].uploadRuleItems[i].id : 0,
                joinFrontTempId: this.fixedSheetTrueData[index].uploadRuleItems[i].joinFrontTempId,
                columnName: this.fixedSheetTrueData[index].uploadRuleItems[i].columnName,
                conditions: [],
                frontTempId: this.fixedSheetTrueData[index].uploadRuleItems[i].frontTempId,
                isAllowNull: this.fixedSheetTrueData[index].uploadRuleItems[i].seniorRuleJson ? this.fixedSheetTrueData[index].uploadRuleItems[i].seniorRuleJson.isAllowNull : true,
                fieldType: (this.fixedSheetTrueData[index].uploadRuleItems[i].seniorRuleJson && this.fixedSheetTrueData[index].uploadRuleItems[i].seniorRuleJson.fieldType) || 3,
                numberFilter: (this.fixedSheetTrueData[index].uploadRuleItems[i].seniorRuleJson && this.fixedSheetTrueData[index].uploadRuleItems[i].seniorRuleJson.numberFilter) || 1,
                JointResultAllowNullList: [
                  {
                    id: true,
                    name: '是'
                  },
                  {
                    id: false,
                    name: '否'
                  }
                ],
                JointResultFieldTypeList: [
                  {
                    id: 1,
                    name: '浮点型'
                  },
                  {
                    id: 2,
                    name: '日期型'
                  },
                  {
                    id: 3,
                    name: '字符串型'
                  },
                  {
                    id: 4,
                    name: '整型'
                  },
                  {
                    id: 5,
                    name: '不验证'
                  }
                ],
                JointResultNumType: [
                  {
                    id: 1,
                    name: '>0'
                  },
                  {
                    id: 2,
                    name: '>=0'
                  },
                  {
                    id: 3,
                    name: '不验证'
                  }
                ],
                isOnChange: false
              }
              this.fixedSheetTrueData[index].allSeniorRuleJsonList.push(data)
            }
          }
          for (let i = 0; i < this.fixedSheetTrueData[index].allSeniorRuleJsonList.length; i++) {
            item.joinNum = this.fixedSheetTrueData[index].allSeniorRuleJsonList[0].joinFrontTempId
            for (let j = 0; j < this.fixedSheetTrueData[index].uploadRuleItems.length; j++) {
              if (this.fixedSheetTrueData[index].allSeniorRuleJsonList[i].joinFrontTempId === this.fixedSheetTrueData[index].uploadRuleItems[j].joinFrontTempId && this.fixedSheetTrueData[index].uploadRuleItems[j].seniorRuleJson) {
                this.fixedSheetTrueData[index].allSeniorRuleJsonList[i].conditions = JSON.parse(JSON.stringify(this.fixedSheetTrueData[index].uploadRuleItems[j].seniorRuleJson.conditions))
              }
              for (let e = 0; e < this.fixedSheetTrueData[index].allSeniorRuleJsonList[i].conditions.length; e++) {
                this.fixedSheetTrueData[index].allSeniorRuleJsonList[i].conditions[e].columnName = this.fixedSheetTrueData[index].allSeniorRuleJsonList[i].columnName
              }
            }
          }
          for (let j = 0; j < this.fixedSheetTrueData[index].allSeniorRuleJsonList.length; j++) {
            for (let e = 0; e < this.fixedSheetTrueData[index].allSeniorRuleJsonList[j].conditions.length; e++) {
              for (let h = 0; h < this.fixedSheetTrueData[index].allSeniorRuleJsonList[j].conditions[e].columns.length; h++) {
                this.fixedSheetTrueData[index].allSeniorRuleJsonList[j].conditions[e].columns[h].JointCriteriaName = this.returnJoinNam(this.fixedSheetTrueData[index])
              }
            }
          }
        } else {
          item.isSenior = 1
        }
        if (type === 1) {
          if (this.fixedSheetTrueData[index].allSeniorRuleJsonList.length > 0) {
            let flag = false
            for (let i = 0; i < this.fixedSheetTrueData[index].allSeniorRuleJsonList.length; i++) {
              if (this.fixedSheetTrueData[index].allSeniorRuleJsonList[i].isOnChange) {
                flag = true
              }
            }
            if (flag) {
              this.$commonJs.doubleComfirm({
                content: '未保存的高级规则将恢复默认，是否确定',
                successFun: msg => {
                  for (let i = 0; i < this.fixedSheetTrueData[index].allSeniorRuleJsonList.length; i++) {
                    this.fixedSheetTrueData[index].allSeniorRuleJsonList[i].isOnChange = false
                  }
                  item.isSenior = 1
                },
                errorFun: msg => {
                  item.isSenior = 2
                }
              })
            }
          }
        }
      } else {
        this.fixedSheetFalse.isSenior = type
        if (type === 2) {
          this.fixedSheetFalse.isSenior = 2
          this.fixedSheetFalse.allSeniorRuleJsonList = []
          for (let i = 0; i < this.fixedSheetFalse.uploadRuleItems.length; i++) {
            if (this.fixedSheetFalse.uploadRuleItems[i].seniorRuleJson) {
              let data = {
                id: this.fixedSheetFalse.uploadRuleItems[i].id > 0 ? this.fixedSheetFalse.uploadRuleItems[i].id : 0,
                joinFrontTempId: this.fixedSheetFalse.uploadRuleItems[i].joinFrontTempId,
                columnName: this.fixedSheetFalse.uploadRuleItems[i].columnName,
                conditions: [],
                frontTempId: this.fixedSheetFalse.uploadRuleItems[i].frontTempId,
                isAllowNull: this.fixedSheetFalse.uploadRuleItems[i].seniorRuleJson ? this.fixedSheetFalse.uploadRuleItems[i].seniorRuleJson.isAllowNull : true,
                fieldType: (this.fixedSheetFalse.uploadRuleItems[i].seniorRuleJson && this.fixedSheetFalse.uploadRuleItems[i].seniorRuleJson.fieldType) || 3,
                numberFilter: (this.fixedSheetFalse.uploadRuleItems[i].seniorRuleJson && this.fixedSheetFalse.uploadRuleItems[i].seniorRuleJson.numberFilter) || 1,
                JointResultAllowNullList: [
                  {
                    id: true,
                    name: '是'
                  },
                  {
                    id: false,
                    name: '否'
                  }
                ],
                JointResultFieldTypeList: [
                  {
                    id: 1,
                    name: '浮点型'
                  },
                  {
                    id: 2,
                    name: '日期型'
                  },
                  {
                    id: 3,
                    name: '字符串型'
                  },
                  {
                    id: 4,
                    name: '整型'
                  },
                  {
                    id: 5,
                    name: '不验证'
                  }
                ],
                JointResultNumType: [
                  {
                    id: 1,
                    name: '>0'
                  },
                  {
                    id: 2,
                    name: '>=0'
                  },
                  {
                    id: 3,
                    name: '不验证'
                  }
                ],
                isOnChange: false
              }
              this.fixedSheetFalse.allSeniorRuleJsonList.push(data)
            }
          }
          for (let i = 0; i < this.fixedSheetFalse.allSeniorRuleJsonList.length; i++) {
            this.fixedSheetFalse.joinNum = this.fixedSheetFalse.allSeniorRuleJsonList[0].joinFrontTempId
            for (let j = 0; j < this.fixedSheetFalse.uploadRuleItems.length; j++) {
              if (this.fixedSheetFalse.allSeniorRuleJsonList[i].joinFrontTempId === this.fixedSheetFalse.uploadRuleItems[j].joinFrontTempId && this.fixedSheetFalse.uploadRuleItems[j].seniorRuleJson) {
                this.fixedSheetFalse.allSeniorRuleJsonList[i].conditions = JSON.parse(JSON.stringify(this.fixedSheetFalse.uploadRuleItems[j].seniorRuleJson.conditions))
              }
            }
            for (let e = 0; e < this.fixedSheetFalse.allSeniorRuleJsonList[i].conditions.length; e++) {
              this.fixedSheetFalse.allSeniorRuleJsonList[i].conditions[e].columnName = this.fixedSheetFalse.allSeniorRuleJsonList[i].columnName
            }
          }
          for (let j = 0; j < this.fixedSheetFalse.allSeniorRuleJsonList.length; j++) {
            for (let e = 0; e < this.fixedSheetFalse.allSeniorRuleJsonList[j].conditions.length; e++) {
              for (let h = 0; h < this.fixedSheetFalse.allSeniorRuleJsonList[j].conditions[e].columns.length; h++) {
                this.fixedSheetFalse.allSeniorRuleJsonList[j].conditions[e].columns[h].JointCriteriaName = this.returnJoinNam(this.fixedSheetFalse)
              }
            }
          }
        } else {
          this.fixedSheetFalse.isSenior = 1
        }
        if (type === 1) {
          if (this.fixedSheetFalse.allSeniorRuleJsonList.length > 0) {
            let flag = false
            for (let i = 0; i < this.fixedSheetFalse.allSeniorRuleJsonList.length; i++) {
              if (this.fixedSheetFalse.allSeniorRuleJsonList[i].isOnChange) {
                flag = true
              }
            }
            if (flag) {
              this.$commonJs.doubleComfirm({
                content: '未保存的高级规则将恢复默认，是否确定',
                successFun: msg => {
                  for (let i = 0; i < this.fixedSheetFalse.allSeniorRuleJsonList.length; i++) {
                    this.fixedSheetFalse.allSeniorRuleJsonList[i].isOnChange = false
                  }
                  this.fixedSheetFalse.isSenior = 1
                },
                errorFun: msg => {
                  this.fixedSheetFalse.isSenior = 2
                }
              })
            }
          }
        }
      }
    },
    addNewSenior (index, indexSen) {
      if (this.detailData.isFixedSheet) {
        this.addJointConditions.columns[0].JointCriteriaName = this.returnJoinNam(this.fixedSheetTrueData[index])
        this.addJointConditions.columnName = this.fixedSheetTrueData[index].allSeniorRuleJsonList[indexSen].columnName
        this.fixedSheetTrueData[index].allSeniorRuleJsonList[indexSen].conditions.push(JSON.parse(JSON.stringify(this.addJointConditions)))
        this.fixedSheetTrueData[index].allSeniorRuleJsonList[indexSen].isOnChange = true
      } else {
        this.addJointConditions.columns[0].JointCriteriaName = this.returnJoinNam(this.fixedSheetFalse)
        this.addJointConditions.columnName = this.fixedSheetFalse.allSeniorRuleJsonList[indexSen].columnName
        this.fixedSheetFalse.allSeniorRuleJsonList[indexSen].conditions.push(JSON.parse(JSON.stringify(this.addJointConditions)))
        this.fixedSheetFalse.allSeniorRuleJsonList[indexSen].isOnChange = true
      }
    },
    deltSenior (index, indexSen) {
      this.$commonJs.doubleComfirm({
        content: '是否删除内容？',
        successFun: msg => {
          if (this.detailData.isFixedSheet) {
            this.fixedSheetTrueData[index].allSeniorRuleJsonList[indexSen].conditions = []
            this.fixedSheetTrueData[index].allSeniorRuleJsonList[indexSen].isOnChange = true
          } else {
            this.fixedSheetFalse.allSeniorRuleJsonList[indexSen].conditions = []
            this.fixedSheetFalse.allSeniorRuleJsonList[indexSen].isOnChange = true
          }
        },
        errorFun: msg => {
        }
      })
    },
    startPositLin (item) {
      if (this.detailData.isFixedSheet) {
        if (item.startPosition === '' || item.startPosition <= 0) {
          this.$commonJs.alertTips({
            type: 'success',
            title: '成功',
            content: '不能为空或小于0',
            stayTime: 5
          })
          item.startPosition = 1
        }
      } else {
        if (this.fixedSheetFalse.startPosition === '' || this.fixedSheetFalse.startPosition <= 0) {
          this.$commonJs.alertTips({
            type: 'success',
            title: '成功',
            content: '不能为空或小于0',
            stayTime: 5
          })
          this.fixedSheetFalse.startPosition = 1
        }
      }
    },
    // 新建规则
    addNewRule (indexBody) {
      if (this.detailData.isFixedSheet) {
        this.addUploadRuleItems.frontTempId = new Date().getTime() + Math.random() * 9999
        this.addUploadRuleItems.isCheckChild = this.fixedSheetTrueData[indexBody].isCheckFather
        this.addUploadRuleItems.joinFrontTempId = this.addUploadRuleItems.id + '/' + this.addUploadRuleItems.frontTempId
        this.fixedSheetTrueData[indexBody].uploadRuleItems.push(JSON.parse(JSON.stringify(this.addUploadRuleItems)))
      } else {
        this.addfixedSheetFalse.frontTempId = new Date().getTime() + Math.random() * 9999
        this.addfixedSheetFalse.isCheckChild = this.fixedSheetFalse.isCheckFather
        this.addfixedSheetFalse.joinFrontTempId = this.addfixedSheetFalse.id + '/' + this.addfixedSheetFalse.frontTempId
        this.fixedSheetFalse.uploadRuleItems.push(JSON.parse(JSON.stringify(this.addfixedSheetFalse)))
      }
      for (let i = 0; i < this.fixedSheetTrueData.length; i++) {
        if (this.fixedSheetTrueData[i].uploadRuleItems.length === 1) {
          this.$set(this.fixedSheetTrueData[i], 'isCheckFather', false)
          for (let j = 0; j < this.fixedSheetTrueData[i].uploadRuleItems.length; j++) {
            this.$set(this.fixedSheetTrueData[i].uploadRuleItems[j], 'isCheckChild', false)
          }
        }
      }
    },
    // 删除单个列
    deltfiledList (indexBody, indexBodyChild) {
      if (this.detailData.isFixedSheet) {
        this.$commonJs.doubleComfirm({
          content: '是否删除所选规则？',
          remark: this.fixedSheetTrueData[indexBody].uploadRuleItems[indexBodyChild].isUnionCheckRepeat ? '所选规则涉及联合查重，请谨慎选择' : '',
          showImg: false,
          successFun: msg => {
            this.fixedSheetTrueData[indexBody].uploadRuleItems.splice(indexBodyChild, 1)
            let num = 0
            for (let i = 0; i < this.fixedSheetTrueData[indexBody].uploadRuleItems.length; i++) {
              if (this.fixedSheetTrueData[indexBody].uploadRuleItems[i].isUnionCheckRepeat) {
                num++
              }
            }
            if (num < 2) {
              for (let i = 0; i < this.fixedSheetTrueData[indexBody].uploadRuleItems.length; i++) {
                this.fixedSheetTrueData[indexBody].uploadRuleItems[i].isUnionCheckRepeat = false
              }
            }
            this.$forceUpdate()
          },
          errorFun: msg => {
          }
        })
      } else {
        this.$commonJs.doubleComfirm({
          content: '是否删除所选规则？',
          remark: this.fixedSheetFalse.uploadRuleItems[indexBodyChild].isUnionCheckRepeat ? '所选规则涉及联合查重，请谨慎选择' : '',
          showImg: false,
          successFun: msg => {
            this.fixedSheetFalse.uploadRuleItems.splice(indexBodyChild, 1)
            let num = 0
            for (let i = 0; i < this.fixedSheetFalse.uploadRuleItems.length; i++) {
              if (this.fixedSheetFalse.uploadRuleItems[i].isUnionCheckRepeat) {
                num++
              }
            }
            if (num < 2) {
              for (let i = 0; i < this.fixedSheetFalse.uploadRuleItems.length; i++) {
                this.fixedSheetFalse.uploadRuleItems[i].isUnionCheckRepeat = false
              }
            }
            this.$forceUpdate()
          },
          errorFun: msg => {
          }
        })
      }
    },
    addShowRules (item, index, indexChild) {
      this.myCtrlFixSheetIndex = index
      this.myCtrlFixSheetIndex_childe = indexChild
      this.fixModelList = JSON.parse(JSON.stringify(item.contentScopeTwo))
      this.showModel = true
    },
    addFixdInput () {
      this.fixModelList.push(JSON.parse(JSON.stringify(this.addfixModel)))
    },
    deltFixInput (index) {
      this.fixModelList.splice(index, 1)
    },
    confixModel () {
      if (this.detailData.isFixedSheet) {
        this.fixedSheetTrueData[this.myCtrlFixSheetIndex].uploadRuleItems[this.myCtrlFixSheetIndex_childe].contentScopeTwo = this.fixModelList
      } else {
        this.fixedSheetFalse.uploadRuleItems[this.myCtrlFixSheetIndex].contentScopeTwo = this.fixModelList
      }
      this.$forceUpdate()
      this.showModel = false
    },
    // 多选删除
    deltAllSheet (index) {
      if (this.detailData.isFixedSheet) {
        let flag = false
        let num = 0
        for (let i = 0; i < this.fixedSheetTrueData[index].uploadRuleItems.length; i++) {
          if (this.fixedSheetTrueData[index].uploadRuleItems[i].isUnionCheckRepeat) {
            num++
          }
        }
        if (num > 1) {
          flag = true
        }
        let that = this
        // let checkNum = 0
        // for (let i = 0; i < that.fixedSheetTrueData[index].uploadRuleItems.length; i++) {
        //   if (that.fixedSheetTrueData[index].uploadRuleItems[i].isCheckChild) {
        //     checkNum++
        //   }
        // }
        // if (parseInt(checkNum) === parseInt(that.fixedSheetTrueData[index].uploadRuleItems.length)) {
        //   that.$commonJs.alertTips({
        //     type: 'error',
        //     title: '失败',
        //     content: '不能删除所有规则',
        //     stayTime: 5
        //   })
        //   return
        // }
        this.$commonJs.doubleComfirm({
          content: '是否删除所选规则？',
          remark: flag ? '所选规则涉及联合查重，请谨慎选择' : '',
          showImg: false,
          successFun: msg => {
            for (let i = 0; i < that.fixedSheetTrueData[index].uploadRuleItems.length; i++) {
              if (that.fixedSheetTrueData[index].uploadRuleItems[i].isCheckChild) {
                that.fixedSheetTrueData[index].uploadRuleItems.splice(i, 1)
                i--
              }
            }
            let JointNum = 0
            for (let i = 0; i < that.fixedSheetTrueData[index].uploadRuleItems.length; i++) {
              if (that.fixedSheetTrueData[index].uploadRuleItems[i].isUnionCheckRepeat) {
                JointNum++
              }
            }
            if (JointNum < 2) {
              for (let i = 0; i < that.fixedSheetTrueData[index].uploadRuleItems.length; i++) {
                that.fixedSheetTrueData[index].uploadRuleItems[i].isUnionCheckRepeat = false
              }
            }
            this.$forceUpdate()
          },
          errorFun: msg => {
          }
        })
      } else {
        let flag = false
        let num = 0
        for (let i = 0; i < this.fixedSheetFalse.uploadRuleItems.length; i++) {
          if (this.fixedSheetFalse.uploadRuleItems[i].isUnionCheckRepeat) {
            num++
          }
        }
        if (num > 1) {
          flag = true
        }
        let that = this
        // let checkNum = 0
        // for (let i = 0; i < that.fixedSheetFalse.uploadRuleItems.length; i++) {
        //   if (that.fixedSheetFalse.uploadRuleItems[i].isCheckChild) {
        //     checkNum++
        //   }
        // }
        // if (parseInt(checkNum) === parseInt(that.fixedSheetFalse.uploadRuleItems.length)) {
        //   that.$commonJs.alertTips({
        //     type: 'error',
        //     title: '失败',
        //     content: '不能删除所有规则',
        //     stayTime: 5
        //   })
        //   return
        // }
        this.$commonJs.doubleComfirm({
          content: '是否删除所选规则？',
          remark: flag ? '所选规则涉及联合查重，请谨慎选择' : '',
          showImg: false,
          successFun: msg => {
            for (let i = 0; i < that.fixedSheetFalse.uploadRuleItems.length; i++) {
              if (that.fixedSheetFalse.uploadRuleItems[i].isCheckChild) {
                that.fixedSheetFalse.uploadRuleItems.splice(i, 1)
                i--
              }
            }
            let JointNum = 0
            for (let i = 0; i < that.fixedSheetFalse.uploadRuleItems.length; i++) {
              if (that.fixedSheetFalse.uploadRuleItems[i].isUnionCheckRepeat) {
                JointNum++
              }
            }
            if (JointNum < 2) {
              for (let i = 0; i < that.fixedSheetFalse.uploadRuleItems.length; i++) {
                that.fixedSheetFalse.uploadRuleItems[i].isUnionCheckRepeat = false
              }
            }
            this.$forceUpdate()
          },
          errorFun: msg => {
          }
        })
      }
    },
    // 添加联合查重
    addJoint (type, item, index) {
      this.myJointModleList = []
      if (parseInt(type) === 1) {
        for (let i = 0; i < item.uploadRuleItems.length; i++) {
          if (item.uploadRuleItems[i].isUnionCheckRepeat || item.uploadRuleItems[i].isCheckChild) {
            this.myJointModleList.push(JSON.parse(JSON.stringify(item.uploadRuleItems[i])))
          }
        }
      } else {
        for (let i = 0; i < this.fixedSheetFalse.uploadRuleItems.length; i++) {
          if (this.fixedSheetFalse.uploadRuleItems[i].isUnionCheckRepeat || this.fixedSheetFalse.uploadRuleItems[i].isCheckChild) {
            this.myJointModleList.push(JSON.parse(JSON.stringify(this.fixedSheetFalse.uploadRuleItems[i])))
          }
        }
      }
      for (let i = 0; i < this.myJointModleList.length; i++) {
        this.myJointModleList[i].isUnionCheckRepeat = true
      }
      this.showModel3 = true
    },
    rmoveJoint (index) {
      this.myJointModleList.splice(index, 1)
    },
    confirmJoint () {
      let num = 0
      for (let i = 0; i < this.myJointModleList.length; i++) {
        if (this.myJointModleList[i].isUnionCheckRepeat) {
          num++
        }
      }
      if (num < 2) {
        this.$commonJs.doubleComfirm({
          content: '无两个以上关联列，将清除联合查重，是否确定？',
          showImg: false,
          successFun: msg => {
            if (this.detailData.isFixedSheet) {
              for (let i = 0; i < this.fixedSheetTrueData[this.seltSheet].uploadRuleItems.length; i++) {
                this.fixedSheetTrueData[this.seltSheet].uploadRuleItems[i].isUnionCheckRepeat = false
                this.fixedSheetTrueData[this.seltSheet].uploadRuleItems[i].isCheckChild = false
              }
              this.fixedSheetTrueData[this.seltSheet].isCheckFather = false
            } else {
              for (let i = 0; i < this.fixedSheetFalse.uploadRuleItems.length; i++) {
                this.fixedSheetFalse.uploadRuleItems[i].isUnionCheckRepeat = false
                this.fixedSheetFalse.uploadRuleItems[i].isCheckChild = false
              }
              this.fixedSheetFalse.isCheckFather = false
            }
            this.$forceUpdate()
            this.showModel3 = false
          },
          errorFun: msg => {
          }
        })
        // this.$commonJs.alertTips({
        //   type: 'error',
        //   title: '错误',
        //   content: '至少选择两列',
        //   stayTime: 5
        // })
        // return
      } else {
        if (this.detailData.isFixedSheet) {
          for (let i = 0; i < this.fixedSheetTrueData[this.seltSheet].uploadRuleItems.length; i++) {
            this.fixedSheetTrueData[this.seltSheet].uploadRuleItems[i].isUnionCheckRepeat = false
            for (let j = 0; j < this.myJointModleList.length; j++) {
              if (parseInt(this.fixedSheetTrueData[this.seltSheet].uploadRuleItems[i].id) === 0) {
                if (this.fixedSheetTrueData[this.seltSheet].uploadRuleItems[i].frontTempId === this.myJointModleList[j].frontTempId) {
                  this.fixedSheetTrueData[this.seltSheet].uploadRuleItems[i].isUnionCheckRepeat = this.myJointModleList[j].isUnionCheckRepeat
                }
              }
              if (parseInt(this.fixedSheetTrueData[this.seltSheet].uploadRuleItems[i].id) !== 0) {
                if (parseInt(this.fixedSheetTrueData[this.seltSheet].uploadRuleItems[i].id) === parseInt(this.myJointModleList[j].id)) {
                  this.fixedSheetTrueData[this.seltSheet].uploadRuleItems[i].isUnionCheckRepeat = this.myJointModleList[j].isUnionCheckRepeat
                }
              }
            }
            this.fixedSheetTrueData[this.seltSheet].uploadRuleItems[i].isCheckChild = false
          }
          this.fixedSheetTrueData[this.seltSheet].isCheckFather = false
          console.log(this.fixedSheetTrueData[this.seltSheet].uploadRuleItems)
          console.log(this.myJointModleList)
        } else {
          for (let i = 0; i < this.fixedSheetFalse.uploadRuleItems.length; i++) {
            this.fixedSheetFalse.uploadRuleItems[i].isUnionCheckRepeat = false
            for (let j = 0; j < this.myJointModleList.length; j++) {
              if (parseInt(this.fixedSheetFalse.uploadRuleItems[i].id) === 0) {
                if (this.fixedSheetFalse.uploadRuleItems[i].frontTempId === this.myJointModleList[j].frontTempId) {
                  this.fixedSheetFalse.uploadRuleItems[i].isUnionCheckRepeat = this.myJointModleList[j].isUnionCheckRepeat
                }
              }
              if (parseInt(this.fixedSheetFalse.uploadRuleItems[i].id) !== 0) {
                if (parseInt(this.fixedSheetFalse.uploadRuleItems[i].id) === parseInt(this.myJointModleList[j].id)) {
                  this.fixedSheetFalse.uploadRuleItems[i].isUnionCheckRepeat = this.myJointModleList[j].isUnionCheckRepeat
                }
              }
            }
            this.fixedSheetFalse.uploadRuleItems[i].isCheckChild = false
          }
          this.fixedSheetFalse.isCheckFather = false
        }
        this.$forceUpdate()
        this.showModel3 = false
      }
    },
    // 高级规则设置
    toJoin (index, indexCl) {
      if (this.detailData.isFixedSheet) {
        this.fixedSheetTrueData[index].allSeniorRuleJsonList = []
        for (let i = 0; i < this.fixedSheetTrueData[index].uploadRuleItems.length; i++) {
          let data = {
            id: this.fixedSheetTrueData[index].uploadRuleItems[i].id > 0 ? this.fixedSheetTrueData[index].uploadRuleItems[i].id : 0,
            joinFrontTempId: this.fixedSheetTrueData[index].uploadRuleItems[i].joinFrontTempId,
            columnName: this.fixedSheetTrueData[index].uploadRuleItems[i].columnName,
            conditions: [],
            frontTempId: this.fixedSheetTrueData[index].uploadRuleItems[i].frontTempId,
            isAllowNull: this.fixedSheetTrueData[index].uploadRuleItems[i].seniorRuleJson ? this.fixedSheetTrueData[index].uploadRuleItems[i].seniorRuleJson.isAllowNull : true,
            fieldType: (this.fixedSheetTrueData[index].uploadRuleItems[i].seniorRuleJson && this.fixedSheetTrueData[index].uploadRuleItems[i].seniorRuleJson.fieldType) || 3,
            numberFilter: (this.fixedSheetTrueData[index].uploadRuleItems[i].seniorRuleJson && this.fixedSheetTrueData[index].uploadRuleItems[i].seniorRuleJson.numberFilter) || 1,
            JointResultAllowNullList: [
              {
                id: true,
                name: '是'
              },
              {
                id: false,
                name: '否'
              }
            ],
            JointResultFieldTypeList: [
              {
                id: 1,
                name: '浮点型'
              },
              {
                id: 2,
                name: '日期型'
              },
              {
                id: 3,
                name: '字符串型'
              },
              {
                id: 4,
                name: '整型'
              },
              {
                id: 5,
                name: '不验证'
              }
            ],
            JointResultNumType: [
              {
                id: 1,
                name: '>0'
              },
              {
                id: 2,
                name: '>=0'
              },
              {
                id: 3,
                name: '不验证'
              }
            ],
            isOnChange: false
          }
          this.fixedSheetTrueData[index].allSeniorRuleJsonList.push(data)
        }
        for (let i = 0; i < this.fixedSheetTrueData[index].allSeniorRuleJsonList.length; i++) {
          for (let j = 0; j < this.fixedSheetTrueData[index].uploadRuleItems.length; j++) {
            if (this.fixedSheetTrueData[index].allSeniorRuleJsonList[i].joinFrontTempId === this.fixedSheetTrueData[index].uploadRuleItems[j].joinFrontTempId && this.fixedSheetTrueData[index].uploadRuleItems[j].seniorRuleJson) {
              this.fixedSheetTrueData[index].allSeniorRuleJsonList[i].conditions = JSON.parse(JSON.stringify(this.fixedSheetTrueData[index].uploadRuleItems[j].seniorRuleJson.conditions))
            }
          }
          for (let e = 0; e < this.fixedSheetTrueData[index].allSeniorRuleJsonList[i].conditions.length; e++) {
            this.fixedSheetTrueData[index].allSeniorRuleJsonList[i].conditions[e].columnName = this.fixedSheetTrueData[index].allSeniorRuleJsonList[i].columnName
          }
        }
        for (let j = 0; j < this.fixedSheetTrueData[index].allSeniorRuleJsonList.length; j++) {
          for (let e = 0; e < this.fixedSheetTrueData[index].allSeniorRuleJsonList[j].conditions.length; e++) {
            for (let h = 0; h < this.fixedSheetTrueData[index].allSeniorRuleJsonList[j].conditions[e].columns.length; h++) {
              this.fixedSheetTrueData[index].allSeniorRuleJsonList[j].conditions[e].columns[h].JointCriteriaName = this.returnJoinNam(this.fixedSheetTrueData[index])
            }
          }
        }
        this.fixedSheetTrueData[index].isSenior = 2
        this.fixedSheetTrueData[index].joinNum = this.fixedSheetTrueData[index].uploadRuleItems[indexCl].joinFrontTempId
        console.log(this.fixedSheetTrueData[index].allSeniorRuleJsonList)
      } else {
        this.fixedSheetFalse.allSeniorRuleJsonList = []
        for (let i = 0; i < this.fixedSheetFalse.uploadRuleItems.length; i++) {
          let data = {
            id: this.fixedSheetFalse.uploadRuleItems[i].id > 0 ? this.fixedSheetFalse.uploadRuleItems[i].id : 0,
            joinFrontTempId: this.fixedSheetFalse.uploadRuleItems[i].joinFrontTempId,
            columnName: this.fixedSheetFalse.uploadRuleItems[i].columnName,
            conditions: [],
            frontTempId: this.fixedSheetFalse.uploadRuleItems[i].frontTempId,
            isAllowNull: this.fixedSheetFalse.uploadRuleItems[i].seniorRuleJson ? this.fixedSheetFalse.uploadRuleItems[i].seniorRuleJson.isAllowNull : true,
            fieldType: (this.fixedSheetFalse.uploadRuleItems[i].seniorRuleJson && this.fixedSheetFalse.uploadRuleItems[i].seniorRuleJson.fieldType) || 3,
            numberFilter: (this.fixedSheetFalse.uploadRuleItems[i].seniorRuleJson && this.fixedSheetFalse.uploadRuleItems[i].seniorRuleJson.numberFilter) || 1,
            JointResultAllowNullList: [
              {
                id: true,
                name: '是'
              },
              {
                id: false,
                name: '否'
              }
            ],
            JointResultFieldTypeList: [
              {
                id: 1,
                name: '浮点型'
              },
              {
                id: 2,
                name: '日期型'
              },
              {
                id: 3,
                name: '字符串型'
              },
              {
                id: 4,
                name: '整型'
              },
              {
                id: 5,
                name: '不验证'
              }
            ],
            JointResultNumType: [
              {
                id: 1,
                name: '>0'
              },
              {
                id: 2,
                name: '>=0'
              },
              {
                id: 3,
                name: '不验证'
              }
            ],
            isOnChange: false
          }
          this.fixedSheetFalse.allSeniorRuleJsonList.push(data)
        }
        for (let i = 0; i < this.fixedSheetFalse.allSeniorRuleJsonList.length; i++) {
          for (let j = 0; j < this.fixedSheetFalse.uploadRuleItems.length; j++) {
            if (this.fixedSheetFalse.allSeniorRuleJsonList[i].joinFrontTempId === this.fixedSheetFalse.uploadRuleItems[j].joinFrontTempId && this.fixedSheetFalse.uploadRuleItems[j].seniorRuleJson) {
              this.fixedSheetFalse.allSeniorRuleJsonList[i].conditions = JSON.parse(JSON.stringify(this.fixedSheetFalse.uploadRuleItems[j].seniorRuleJson.conditions))
            }
          }
          for (let e = 0; e < this.fixedSheetFalse.allSeniorRuleJsonList[i].conditions.length; e++) {
            this.fixedSheetFalse.allSeniorRuleJsonList[i].conditions[e].columnName = this.fixedSheetFalse.allSeniorRuleJsonList[i].columnName
          }
        }
        for (let j = 0; j < this.fixedSheetFalse.allSeniorRuleJsonList.length; j++) {
          for (let e = 0; e < this.fixedSheetFalse.allSeniorRuleJsonList[j].conditions.length; e++) {
            for (let h = 0; h < this.fixedSheetFalse.allSeniorRuleJsonList[j].conditions[e].columns.length; h++) {
              this.fixedSheetFalse.allSeniorRuleJsonList[j].conditions[e].columns[h].JointCriteriaName = this.returnJoinNam(this.fixedSheetFalse)
            }
          }
        }
        this.fixedSheetFalse.isSenior = 2
        this.fixedSheetFalse.joinNum = this.fixedSheetFalse.uploadRuleItems[indexCl].joinFrontTempId
        console.log(this.fixedSheetFalse)
      }
    },
    sweetenCondition (index, indexCont) {
      if (this.detailData.isFixedSheet) {
        this.addJointConditions.columnName = this.fixedSheetTrueData[index].allSeniorRuleJsonList[indexCont].columnName
        for (let i = 0; i < this.addJointConditions.columns.length; i++) {
          this.addJointConditions.columns[i].JointCriteriaName = JSON.parse(JSON.stringify(this.returnJoinNam(this.fixedSheetTrueData[this.seltSheet])))
        }
        this.fixedSheetTrueData[index].allSeniorRuleJsonList[indexCont].conditions.push(JSON.parse(JSON.stringify(this.addJointConditions)))
        for (let i = 0; i < this.fixedSheetTrueData[index].allSeniorRuleJsonList[indexCont].conditions.length; i++) {
          this.fixedSheetTrueData[index].allSeniorRuleJsonList[indexCont].conditions[i].orderId = i
        }
        this.fixedSheetTrueData[index].allSeniorRuleJsonList[indexCont].isOnChange = true
        console.log(this.fixedSheetTrueData[index].allSeniorRuleJsonList[indexCont].conditions)
      } else {
        this.addJointConditions.columnName = this.fixedSheetFalse.allSeniorRuleJsonList[indexCont].columnName
        for (let i = 0; i < this.addJointConditions.columns.length; i++) {
          this.addJointConditions.columns[i].JointCriteriaName = JSON.parse(JSON.stringify(this.returnJoinNam(this.fixedSheetFalse)))
        }
        this.fixedSheetFalse.allSeniorRuleJsonList[indexCont].conditions.push(JSON.parse(JSON.stringify(this.addJointConditions)))
        for (let i = 0; i < this.fixedSheetFalse.allSeniorRuleJsonList[indexCont].conditions.length; i++) {
          this.fixedSheetFalse.allSeniorRuleJsonList[indexCont].conditions[i].orderId = i
        }
        this.fixedSheetFalse.allSeniorRuleJsonList[indexCont].isOnChange = true
        console.log(this.fixedSheetFalse.allSeniorRuleJsonList[indexCont].conditions)
      }
    },
    deltCondit (index, indexJoin, indexCond) {
      if (this.detailData.isFixedSheet) {
        this.fixedSheetTrueData[index].allSeniorRuleJsonList[indexJoin].conditions.splice(indexCond, 1)
      } else {
        this.fixedSheetFalse.allSeniorRuleJsonList[indexJoin].conditions.splice(indexCond, 1)
      }
    },
    sweetenColumns (index, indexJoin, indexCols) {
      if (this.detailData.isFixedSheet) {
        this.addColumns.JointCriteriaName = JSON.parse(JSON.stringify(this.returnJoinNam(this.fixedSheetTrueData[index])))
        this.fixedSheetTrueData[index].allSeniorRuleJsonList[indexJoin].conditions[indexCols].columns.push(JSON.parse(JSON.stringify(this.addColumns)))
        this.fixedSheetTrueData[index].allSeniorRuleJsonList[indexJoin].isOnChange = true
      } else {
        this.addColumns.JointCriteriaName = JSON.parse(JSON.stringify(this.returnJoinNam(this.fixedSheetFalse)))
        this.fixedSheetFalse.allSeniorRuleJsonList[indexJoin].conditions[indexCols].columns.push(JSON.parse(JSON.stringify(this.addColumns)))
        this.fixedSheetFalse.allSeniorRuleJsonList[indexJoin].isOnChange = true
      }
    },
    delColumns (index, indexJoin, indexCot, indexCols) {
      if (this.detailData.isFixedSheet) {
        this.fixedSheetTrueData[index].allSeniorRuleJsonList[indexJoin].conditions[indexCot].columns.splice(indexCols, 1)
        this.fixedSheetTrueData[index].allSeniorRuleJsonList[indexJoin].isOnChange = true
      } else {
        this.fixedSheetFalse.allSeniorRuleJsonList[indexJoin].conditions[indexCot].columns.splice(indexCols, 1)
        this.fixedSheetFalse.allSeniorRuleJsonList[indexJoin].isOnChange = true
      }
    },
    seltColFileType (e, item, index) {
      if (this.detailData.isFixedSheet) {
        item.id = e.id
        item.fieldType = e.fieldType
        item.activeOperator = 0
        item.data = ''
        item.frontTempId = e.frontTempId
        this.fixedSheetTrueData[this.seltSheet].allSeniorRuleJsonList[index].isOnChange = true
      } else {
        item.id = e.id
        item.fieldType = e.fieldType
        item.activeOperator = 0
        item.data = ''
        item.frontTempId = e.frontTempId
        this.fixedSheetFalse.allSeniorRuleJsonList[index].isOnChange = true
      }
    },
    seltActiveOperator (e, item, index) {
      if (this.detailData.isFixedSheet) {
        this.fixedSheetTrueData[this.seltSheet].allSeniorRuleJsonList[index].isOnChange = true
      } else {
        this.fixedSheetFalse.allSeniorRuleJsonList[index].isOnChange = true
      }
    },
    seltSuffix () {
      if (this.detailData.separator === '_' || this.detailData.separator === '-') {
        this.detailData.suffix = 'yyyy'
      }
    },
    seltFileType () {
      this.seltSheet = 0
      let list = JSON.parse(JSON.stringify(this.fixedSheetTrueData[0]))
      this.fixedSheetTrueData = []
      this.fixedSheetTrueData.push(JSON.parse(JSON.stringify(list)))
    },
    allSave () {
      if (!this.detailData.fileName) {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '请输入文件名',
          stayTime: 5
        })
        return
      }
      this.detailData.suffix = this.detailData.separator ? this.detailData.suffix : ''
      if (parseInt(this.detailData.uploadFrequency) === 1 && this.mouthTimeOne === '' && this.mouthTimeTwo === '') {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '请至少填写一个工作日',
          stayTime: 5
        })
        return
      }
      if (parseInt(this.detailData.uploadFrequency) === 2 && this.yearOneTime === '' && this.yearTwoTime === '') {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '请至少填写一个工作日',
          stayTime: 5
        })
        return
      }
      if (parseInt(this.detailData.fileSizeLimit) > 200) {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '文件大小不能大于200M',
          stayTime: 5
        })
        return
      } else if (parseInt(this.detailData.fileSizeLimit) <= 0) {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '文件大小不能小于等于0',
          stayTime: 5
        })
        return
      }
      if (this.detailData.isEnabledMainEmailReminder && this.detailData.mainEmailReminder === '') {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '请输入邮件提醒人',
          stayTime: 5
        })
        return
      }
      if (this.detailData.isEnabledBackupEmailReminder && this.detailData.backupEmailReminder === '') {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '请输入邮件Backup',
          stayTime: 5
        })
        return
      }
      if (!this.detailData.account || !this.detailData.container) {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '请选择blob账号',
          stayTime: 5
        })
        return
      }
      if (!this.detailData.startPath) {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '请输入上传路径',
          stayTime: 5
        })
        return
      }
      if (parseInt(this.detailData.uploadFrequency) === 1) {
        this.detailData.remindTime = this.mouthTimeOne + ',' + this.mouthTimeTwo
      } else if (parseInt(this.detailData.uploadFrequency) === 2) {
        this.detailData.remindTime = this.yearOne + '/' + this.yearOneTime + ',' + this.yearTwo + '/' + this.yearTwoTime
      }
      this.detailData.fileSizeLimit = parseInt(this.detailData.fileSizeLimit)

      if (this.detailData.isFixedSheet) {
        for (let i = 0; i < this.fixedSheetTrueData.length; i++) {
          console.log(this.fixedSheetTrueData)
          this.fixedSheetTrueData[i].startPosition = parseInt(this.fixedSheetTrueData[i].startPosition)
          if (!this.fixedSheetTrueData[i].sheetName && parseInt(this.detailData.fileFormat) === 1) {
            this.$commonJs.alertTips({
              type: 'error',
              title: '错误',
              content: '请输入sheet名',
              stayTime: 5
            })
            return
          }
          for (let j = 0; j < this.fixedSheetTrueData[i].uploadRuleItems.length; j++) {
            if (!this.fixedSheetTrueData[i].uploadRuleItems[j].columnName) {
              this.$commonJs.alertTips({
                type: 'error',
                title: '错误',
                content: '请输入列名',
                stayTime: 5
              })
              return
            }
            this.fixedSheetTrueData[i].uploadRuleItems[j].orderId = parseInt(j) + 1
            this.fixedSheetTrueData[i].uploadRuleItems[j].contentScope = []
            if (this.fixedSheetTrueData[i].uploadRuleItems[j].contentScopeTwo.length > 0) {
              this.fixedSheetTrueData[i].uploadRuleItems[j].contentScope = parseInt(this.fixedSheetTrueData[i].uploadRuleItems[j].fieldType) !== 3 ? [] : this.fixedSheetTrueData[i].uploadRuleItems[j].contentScopeTwo.map(p => { return p.name })
            }
            // this.fixedSheetTrueData[i].uploadRuleItems[j].seniorRuleJson = null
          }
          if (this.fixedSheetTrueData[i].allSeniorRuleJsonList) {
            for (let e = 0; e < this.fixedSheetTrueData[i].allSeniorRuleJsonList.length; e++) {
              if (this.fixedSheetTrueData[i].allSeniorRuleJsonList[e].conditions.length === 0) {
                for (let o = 0; o < this.fixedSheetTrueData[i].uploadRuleItems.length; o++) {
                  if (this.fixedSheetTrueData[i].uploadRuleItems[o].joinFrontTempId === this.fixedSheetTrueData[i].allSeniorRuleJsonList[e].joinFrontTempId) {
                    this.fixedSheetTrueData[i].uploadRuleItems[o].seniorRuleJson = null
                  }
                }
              }
              if (this.fixedSheetTrueData[i].allSeniorRuleJsonList[e].conditions.length > 0) {
                for (let g = 0; g < this.fixedSheetTrueData[i].allSeniorRuleJsonList[e].conditions.length; g++) {
                  let fistFlag = false
                  for (let h = 0; h < this.fixedSheetTrueData[i].allSeniorRuleJsonList[e].conditions[g].columns.length; h++) {
                    if (this.fixedSheetTrueData[i].allSeniorRuleJsonList[e].conditions[g].columns[h].joinFrontTempId === '' || this.fixedSheetTrueData[i].allSeniorRuleJsonList[e].conditions[g].columns[h].activeOperator === 0 || this.fixedSheetTrueData[i].allSeniorRuleJsonList[e].conditions[g].columns[h].activeOperator === '' || this.fixedSheetTrueData[i].allSeniorRuleJsonList[e].conditions[g].columns[h].data === '') {
                      fistFlag = true
                    }
                  }
                  if (fistFlag) {
                    this.$commonJs.alertTips({
                      type: 'error',
                      title: '错误',
                      content: '请选择高级规则的列名，操作符和值',
                      stayTime: 5
                    })
                    return
                  }
                  for (let h = 0; h < this.fixedSheetTrueData[i].allSeniorRuleJsonList[e].conditions[g].columns.length; h++) {
                    let flag = false
                    for (let o = 0; o < this.fixedSheetTrueData[i].uploadRuleItems.length; o++) {
                      if (parseInt(this.fixedSheetTrueData[i].allSeniorRuleJsonList[e].conditions[g].columns[h].id) === parseInt(this.fixedSheetTrueData[i].uploadRuleItems[o].id)) {
                        flag = true
                      }
                    }
                    if (!flag) {
                      this.$commonJs.alertTips({
                        type: 'error',
                        title: '错误',
                        content: '请选择高级规则的列名，操作符和值',
                        stayTime: 5
                      })
                      return
                    }
                  }
                }
                for (let o = 0; o < this.fixedSheetTrueData[i].uploadRuleItems.length; o++) {
                  if (this.fixedSheetTrueData[i].uploadRuleItems[o].joinFrontTempId === this.fixedSheetTrueData[i].allSeniorRuleJsonList[e].joinFrontTempId) {
                    this.fixedSheetTrueData[i].uploadRuleItems[o].seniorRuleJson = JSON.parse(JSON.stringify(this.fixedSheetTrueData[i].allSeniorRuleJsonList[e]))
                  }
                }
              }
            }
          }
        }
        this.detailData.sheets = JSON.parse(JSON.stringify(this.fixedSheetTrueData))
      } else {
        this.detailData.sheets = []
        this.fixedSheetFalse.startPosition = parseInt(this.fixedSheetFalse.startPosition)
        for (let i = 0; i < this.fixedSheetFalse.uploadRuleItems.length; i++) {
          if (!this.fixedSheetFalse.uploadRuleItems[i].columnName) {
            this.$commonJs.alertTips({
              type: 'error',
              title: '错误',
              content: '请输入列名',
              stayTime: 5
            })
            return
          }
          this.fixedSheetFalse.uploadRuleItems[i].orderId = parseInt(i) + 1
          this.fixedSheetFalse.uploadRuleItems[i].contentScope = []
          if (this.fixedSheetFalse.uploadRuleItems[i].contentScopeTwo.length > 0) {
            this.fixedSheetFalse.uploadRuleItems[i].contentScope = parseInt(this.fixedSheetFalse.uploadRuleItems[i].fieldType) !== 3 ? [] : this.fixedSheetFalse.uploadRuleItems[i].contentScopeTwo.map(p => { return p.name })
          }
        }
        for (let e = 0; e < this.fixedSheetFalse.allSeniorRuleJsonList.length; e++) {
          if (this.fixedSheetFalse.allSeniorRuleJsonList[e].conditions.length === 0) {
            for (let o = 0; o < this.fixedSheetFalse.uploadRuleItems.length; o++) {
              if (this.fixedSheetFalse.uploadRuleItems[o].joinFrontTempId === this.fixedSheetFalse.allSeniorRuleJsonList[e].joinFrontTempId) {
                this.fixedSheetFalse.uploadRuleItems[o].seniorRuleJson = null
              }
            }
          }
          if (this.fixedSheetFalse.allSeniorRuleJsonList[e].conditions.length > 0) {
            for (let g = 0; g < this.fixedSheetFalse.allSeniorRuleJsonList[e].conditions.length; g++) {
              let fistFlag = false
              for (let h = 0; h < this.fixedSheetFalse.allSeniorRuleJsonList[e].conditions[g].columns.length; h++) {
                if (this.fixedSheetFalse.allSeniorRuleJsonList[e].conditions[g].columns[h].joinFrontTempId === '' || this.fixedSheetFalse.allSeniorRuleJsonList[e].conditions[g].columns[h].activeOperator === 0 || this.fixedSheetFalse.allSeniorRuleJsonList[e].conditions[g].columns[h].activeOperator === '' || this.fixedSheetFalse.allSeniorRuleJsonList[e].conditions[g].columns[h].data === '') {
                  fistFlag = true
                }
              }
              if (fistFlag) {
                this.$commonJs.alertTips({
                  type: 'error',
                  title: '错误',
                  content: '请选择高级规则的列名，操作符和值',
                  stayTime: 5
                })
                return
              }
              for (let h = 0; h < this.fixedSheetFalse.allSeniorRuleJsonList[e].conditions[g].columns.length; h++) {
                let flag = false
                for (let o = 0; o < this.fixedSheetFalse.uploadRuleItems.length; o++) {
                  if (parseInt(this.fixedSheetFalse.allSeniorRuleJsonList[e].conditions[g].columns[h].id) === parseInt(this.fixedSheetFalse.uploadRuleItems[o].id)) {
                    flag = true
                  }
                }
                if (!flag) {
                  this.$commonJs.alertTips({
                    type: 'error',
                    title: '错误',
                    content: '请选择高级规则的列名，操作符和值',
                    stayTime: 5
                  })
                  return
                }
              }
            }
            for (let o = 0; o < this.fixedSheetFalse.uploadRuleItems.length; o++) {
              if (this.fixedSheetFalse.uploadRuleItems[o].joinFrontTempId === this.fixedSheetFalse.allSeniorRuleJsonList[e].joinFrontTempId) {
                this.fixedSheetFalse.uploadRuleItems[o].seniorRuleJson = JSON.parse(JSON.stringify(this.fixedSheetFalse.allSeniorRuleJsonList[e]))
              }
            }
          }
        }
        this.detailData.sheets.push(JSON.parse(JSON.stringify(this.fixedSheetFalse)))
      }
      // 删除不必要数组
      for (let i = 0; i < this.detailData.sheets.length; i++) {
        delete this.detailData.sheets[i].allSeniorRuleJsonList
        for (let j = 0; j < this.detailData.sheets[i].uploadRuleItems.length; j++) {
          if (this.detailData.sheets[i].uploadRuleItems[j].seniorRuleJson) {
            for (let e = 0; e < this.detailData.sheets[i].uploadRuleItems[j].seniorRuleJson.conditions.length; e++) {
              for (let h = 0; h < this.detailData.sheets[i].uploadRuleItems[j].seniorRuleJson.conditions[e].columns.length; h++) {
                delete this.detailData.sheets[i].uploadRuleItems[j].seniorRuleJson.conditions[e].columns[h].JointCriteriaName
              }
            }
          }
        }
      }
      this.detailData.endPath = !this.detailData.midPath ? '' : this.detailData.endPath
      console.log(this.detailData)
      var combine = this.detailData.fileName + this.detailData.separator + this.detailData.suffix
      var remark = this.detailData.separator ? combine : this.detailData.fileName
      if (this.formId) {
        this.$commonJs.addLog('更新', '系统管理', '数据规则校验', remark)
      }
      // return
      this.$axiox.post('/api/FileSet/UpsetUploadItem', this.detailData).then(msg => {
        if (!this.formId) {
          this.$commonJs.addLog('新建', '系统管理', '数据规则校验', remark)
        }
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '保存成功',
          stayTime: 5
        })
        this.$router.go(-1)
      })
    },
    goUrl () {
      this.$router.go(-1)
    },
    // 固定Sheet全选和单选
    titleCheckOne (index) {
      for (let i = 0; i < this.fixedSheetTrueData[index].uploadRuleItems.length; i++) {
        this.$set(this.fixedSheetTrueData[index].uploadRuleItems[i], 'isCheckChild', this.fixedSheetTrueData[index].isCheckFather)
      }
    },
    listCheckedOne (index) {
      let flag = true
      for (let i = 0; i < this.fixedSheetTrueData[index].uploadRuleItems.length; i++) {
        if (!this.fixedSheetTrueData[index].uploadRuleItems[i].isCheckChild) {
          flag = false
        }
      }
      if (flag) {
        // this.fixedSheetTrueData[index].isCheckFather = true
        this.$set(this.fixedSheetTrueData[index], 'isCheckFather', true)
      } else {
        // this.fixedSheetTrueData[index].isCheckFather = false
        this.$set(this.fixedSheetTrueData[index], 'isCheckFather', false)
      }
    },
    // 固定Sheet全选和单选
    titleCheckTwo () {
      for (let i = 0; i < this.fixedSheetFalse.uploadRuleItems.length; i++) {
        this.$set(this.fixedSheetFalse.uploadRuleItems[i], 'isCheckChild', this.fixedSheetFalse.isCheckFather)
      }
    },
    listCheckedTwo () {
      let flag = true
      for (let i = 0; i < this.fixedSheetFalse.uploadRuleItems.length; i++) {
        if (!this.fixedSheetFalse.uploadRuleItems[i].isCheckChild) {
          flag = false
        }
      }
      if (flag) {
        this.fixedSheetFalse.isCheckFather = true
      } else {
        this.fixedSheetFalse.isCheckFather = false
      }
    },
    returnJoinNam (item) {
      let list = []
      for (let i = 0; i < item.uploadRuleItems.length; i++) {
        let data = {
          id: item.uploadRuleItems[i].id,
          fieldType: item.uploadRuleItems[i].fieldType,
          frontTempId: item.uploadRuleItems[i].frontTempId,
          joinFrontTempId: item.uploadRuleItems[i].joinFrontTempId || item.uploadRuleItems[i].id + '/' + item.uploadRuleItems[i].frontTempId,
          columnName: item.uploadRuleItems[i].columnName
        }
        list.push(data)
      }
      return list
    },
    returnTitle (item) {
      let list = []
      list = item.map(p => { return p.name })
      return list.join(',')
    }
  }
}
</script>

<style scoped>
.listGrop {
  width: 100%;
  display: contents;
}
.tableHeight {
  max-height: calc(100vh - 210px);
}
@media screen and (max-width: 1370px) {
  .tableHeight {
    max-height: calc(100vh - 180px);
  }
}
.bottom_btn {
  text-align: center;
  padding-bottom: 20px;
}
.onUhSpan, .onValSpan{
  color: #59D9A3;
  border:none;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/mySystemMessager/myValidationDetail.vue